// COCHE §10.1.10 — English (Hong Kong). Mirror the keys in zh_cn.ts.
export default {
	common: {
		save: "Save",
		cancel: "Cancel",
		delete: "Delete",
		edit: "Edit",
		search: "Search",
		export: "Export",
		import: "Import",
		confirm: "Confirm",
		yes: "Yes",
		no: "No",
		add: "Add",
		back: "Back",
		close: "Close",
		operation: "Operation",
		loading: "Loading…",
		empty: "No data",
		opSuccess: "Operation successful",
		opFailed: "Operation failed",
		submit: "Submit",
		reset: "Reset",
		reload: "Reload",
		view: "View",
		more: "More",
		all: "All",
		tip: "Notice",
		confirmDelete: "Delete this item?",
		pleaseSelect: "Please select",
		loadFailed: "Failed to load",
		downloadSuccess: "Downloaded",
		warning: "Warning",
		operationSuccess: "Done",
		pleaseInput: "Please enter",
		deleteSuccess: "Deleted",
		editSuccess: "Edited successfully",
		addSuccess: "Added successfully",
		viewSource: "OCR source",
		confirmDeleteRecord: "Delete this record?",
		recordSeqHeader: "No.",
		detail: "Details",
		requiredFieldHint: "Missing required fields. Tap submit again to jump to the first one.",
	},
	auth: {
		sessionExpired: "Your session has expired. Please sign in again.",
		permissionDenied: "You don't have permission for this action.",
		networkError: "Can't reach the server. Please check your connection.",
		serverUnavailable: "The server is temporarily unavailable. Please try again later.",
	},
	login: {
		title: "Sign in",
		username: "Username",
		password: "Password",
		submit: "Sign in",
		captcha: "Captcha",
		rememberMe: "Remember me",
		welcome: "Welcome back",
		signIn: "Sign in",
		platformTitle: "Clinical Research Database",
		platformTagline: "Efficient, flexible clinical-research data captured end-to-end.",
		sxswTitle: "Shaanxi Neurosurgery Quality Control Centre — Data Capture System",
		bgAlt: "Background",
		tabPassword: "Password",
		tabSms: "SMS code",
		tabWechat: "WeChat QR",
		usernamePh: "Please enter your username",
		passwordPh: "Please enter your password",
		mobilePh: "Please enter your mobile number",
		smsCodePh: "Please enter the SMS code",
		captchaPh: "Captcha",
		invalidMobile: "Please enter a valid 11-digit mobile number",
		getCode: "Get code",
		resendCode: "Resend in {sec}s",
		smsSent: "SMS code sent successfully",
		copyright: "© 2026 Beijing IMLES Technology Co., Ltd. ICP filing 19052789-1",
		icpFiling: "Beijing PSB filing 11011302007191",
		platformTitleMycoach: "Clinical Data Platform",
		platformTaglineMycoach: "Unlock Clinical Data",
		copyrightMycoach: "© 2026 Mycoach Health Limited. All rights reserved. Compliant with HIPAA and PIPEDA standards.",
	},
	nav: {
		dashboard: "Dashboard",
		patients: "Patients",
		projects: "Projects",
		schema: "Schema",
		governance: "Governance",
		settings: "Settings",
		logout: "Sign out",
	},
	locale: {
		switcher: "Language",
		en_hk: "English",
		zh_hk: "繁體中文",
		zh_cn: "简体中文",
	},
	i18n: {
		schemaTranslate: {
			title: "Schema translation",
			scanProject: "Scan project for gaps",
			draftWithLlm: "Draft with LLM",
			applySelected: "Save selected",
			columnSource: "Source",
			columnSuggestion: "LLM draft",
			columnEdited: "Your edit",
			noMissing: "All schema labels for this project are already translated.",
		},
	},
	imaging: {
		title: "Imaging viewer",
		subtitle: "COCHE Tier-B — B2 viewer · B4 annotation (cvd_hk)",
		studies: "Studies",
		series: "Series",
		viewer: "Viewer",
		reload: "Reload",
		loading: "Loading…",
		prev: "Prev",
		next: "Next",
		workspace: "Workspace",
		metadata: "Metadata",
		task: "Task",
		noImaging: "No imaging for this patient",
		selectSeries: "Select a series",
		layersShort: "layers",
		frame: "Frame",
		slice: "Slice",
		phase: "Phase",
		axial: "Axial",
		coronal: "Coronal",
		sagittal: "Sagittal",
		play: "Play",
		pause: "Pause",
		playHint: "space bar plays / pauses · ← → phase · ↑ ↓ slice",
		localBuffer: "In this browser",
		bufferLoading: "loading {n}/{total} {unit}s…",
		bufferDone: "all {n} {unit}s loaded ✓",
		bufferLayers: "with {n} layer(s)",
		wlAuto: "auto",
		display: "Display",
		brightness: "Brightness",
		contrast: "Contrast",
		wlCtSoft: "CT soft tissue (400/40)",
		wlCtLung: "CT lung (1500/−600)",
		wlCtBone: "CT bone (2000/300)",
		wlCtBrain: "CT brain (80/40)",
		wlCtVascular: "CT vascular (600/150)",
		wlBrighter: "brighter",
		wlDarker: "darker",
		wlContrastHi: "higher contrast",
		wlContrastLo: "softer",
		wlFullRange: "full range",
		wlCustom: "custom",
		zoom: "Zoom",
		reset: "Reset",
		aiSegment: "AI segment",
		segDialogTitle: "AI segmentation — which structures do you need?",
		toolGrow3d: "3-D grow",
		segPhase: "Phase",
		segPhaseHint: "one echo / b-value of the stack is segmented as a volume",
		segOffNotVolume: "AI segmentation reads a 3-D volume; this is a 2-D series of {n} separate images. Outline it with brush, polygon or region grow instead.",
		segOffRole: "This series is scanner housekeeping, not an acquisition — excluded from AI segmentation by design.",
		structureLabel: "Label",
		resolveNoPermission: "Your role can decide a task but not create one — that separation is deliberate. Ask an administrator or an uploader to create it from this series; the two layers are taken as they are, and you adjudicate.",
		acceptAs: "Accept {who}",
		acceptHint: "One of you decides which outline stands. Reversible, and recorded in that layer's history.",
		acceptNeedsSubmitted: "Only a finished layer can be accepted \u2014 the author marks it done first.",
		acceptedOk: "Layer #{id} is now the reference for this series",
		referenceTag: "Reference",
		referenceHint: "Accepted for this series. The other layers stay as they are \u2014 nothing is deleted.",
		withdrawReference: "Withdraw",
		resolveInTask: "Resolve in a task \u2192",
		resolveTitle: "Resolve this disagreement",
		resolveIntro: "A task is what lets someone decide. It takes these two layers as they are \u2014 nobody redraws \u2014 names who adjudicates, and records the decision and the gold layer.",
		resolveReaders: "Readers",
		resolveLabels: "Labels",
		resolveAdjHint: "who decides \u2014 must be someone other than a reader to mean anything",
		resolveCreate: "Create and adjudicate",
		resolveCreated: "Task #{id} created \u00b7 {status}",
		resolveNeedsPair: "Pick two layers by different people, sharing at least one label.",
		agreementTitle: "Reader agreement",
		agreementSub: "two layers on this series, scored where both were asked for the same label",
		agreementSameAuthor: "Both layers are by the same author — this is a self-comparison, not reader agreement.",
		agreementNoOverlap: "These two layers share no label, so there is nothing to score.",
		agreementHint: "Dice is overlap; kappa is how much of it beats chance. A task adds the whole panel, an adjudicator and a gold layer.",
		meanDice: "mean Dice",
		voxelsA: "Voxels A",
		voxelsB: "Voxels B",
		segBackend: "Runs on",
		segBackendLocal: "This machine (CPU)",
		segBackendGpu: "GPU node (Xi'an)",
		segBackendHint: "The GPU node is not used automatically — pick it deliberately, and the run fails rather than falling back so the result is never mistaken for a GPU one.",
		segQuality: "Quality",
		segFull: "full resolution",
		segFast: "fast (3 mm)",
		acrossSlices: "Across slices",
		keySlices: "key slices",
		prevKey: "previous key slice",
		nextKey: "next key slice",
		copyPrev: "← copy to previous",
		copyNext: "copy to next →",
		interpolate: "Interpolate between key slices",
		interpolated: "{n} slices filled",
		segTarget: "Target",
		segStructures: "structures",
		segAllStructures: "every structure the model knows",
		segRun: "Run",
		measurements: "Measurements — structure volumes from AI / gold layers",
		measDate: "Date",
		analysisTable: "Analysis table — one row per structure",
		analysisTableShort: "Analysis table",
		scopePatientEyebrow: "Patient",
		allPatients: "All patients",
		refreshList: "Refresh the study list",
		scopeSeries: "this series",
		scopePatient: "whole patient",
		featLength: "extent mm",
		role_diagnostic: "diagnostic",
		role_localizer: "localizer",
		cine_gated: "cine (gated)",
		cine_gated_stack: "cine stack",
		cine_loop: "cine loop",
		cine_multiacq: "multi-acquisition",
		cine_frames: "frame series",
		cine_none: "",
		nonDicomHint: "Not DICOM — no pixel spacing or acquisition metadata, so measurements are in pixels and there is no header to de-identify.",
		role_calibration: "calibration",
		role_radial: "radial slabs",
		role_fragment: "stray frame",
		role_derived: "derived map",
		role_capture: "screen capture",
		analysisTableHint: "volume / calibre / intensity (× = ratio to the reference structure) from AI, manual and gold layers; the CSV carries every column",
		downloadCsv: "CSV",
		featDiam: "Ø max mm",
		featIntensity: "Intensity",
		measSeries: "Series",
		measStructure: "Structure",
		measSource: "Source",
		segStarted: "Segmentation started on {backend}",
		saving: "Saving…",
		frameUnavailable: "Frame not available (pixels not cached)",
		layers: "Layers",
		newLayer: "New layer",
		noLayers: "No annotation layers yet",
		opacity: "Opacity",
		delete: "Delete",
		deleteLayerConfirm: "Delete layer #{id}? This cannot be undone.",
		tools: "Drawing tools",
		toolNone: "Pan",
		toolBrush: "Brush",
		toolEraser: "Eraser",
		toolPolygon: "Polygon",
		toolGrow: "Region grow",
		radius: "Radius",
		tolerance: "Tolerance",
		toolHint: "Brush / eraser: drag. Polygon: click points, double-click to close. Region grow: click a seed pixel. Every stroke is saved to the selected label. Pan: drag with the Pan tool, or middle-drag at any time; wheel zooms. Slices: ‹ › or ↑ ↓.",
		undo: "Undo",
		redo: "Redo",
		undoHint: "Undo the last edit on this layer (Ctrl+Z)",
		redoHint: "Redo the edit just undone (Ctrl+Shift+Z)",
		sliceBack: "previous slice (↓)",
		sliceFwd: "next slice (↑)",
		sliceBack5: "back 5 slices",
		sliceFwd5: "forward 5 slices",
		keyShort: "key",
		acrossNone: "Nothing drawn yet for {label} in this plane — draw on a {axis} to start.",
		acrossOne: "One key {axis} for {label}. Step to another {axis}, draw there, then interpolate between them.",
		acrossOffKey: "Copy works from a {axis} that already has {label} on it — use ◀ key / key ▶ to reach one.",
		readOnlyLayer: "This layer is read-only (only your own draft layers can be edited).",
		submitReview: "Submit for review",
		submitHint: "Task \u00b7 {title}",
		markDone: "\u2713 Annotation done",
		markDoneHint: "Freezes this layer as your finished work. You can reopen it.",
		markDoneConfirm: "Mark layer #{id} as done? It becomes read-only \u2014 reopen it any time to keep editing.",
		markDoneOk: "Layer #{id} marked done",
		doneTag: "Done",
		reopen: "Reopen for editing",
		reopenHint: "Back to draft so you can keep annotating.",
		reopenedOk: "Layer #{id} reopened",
		submitConfirm: "Submit your layer? It becomes read-only and agreement with the other reader is computed once everyone has submitted.",
		submitted: "Submitted",
		phiRemoved: "PHI removed on ingest",
		studiesShort: "studies",
		framesShort: "frames",
		filesShort: "files",
		metaSummary: "Summary",
		metaDicom: "DICOM header",
		notDicom: "Not a DICOM series",
		filterTags: "Filter tag / attribute / value",
		followFrame: "Follow current frame",
		instance: "Instance",
		reformatNote: "reformat view — showing the first instance",
		tag: "Tag",
		attribute: "Attribute",
		value: "Value",
		chooseLabels: "Choose labels",
		labelName: "Label name",
		addLabel: "Add label",
		presetPick: "Pick a set — one click starts the layer",
		presetNone: "No set fits this modality — pick labels below",
		pickLabels: "Or pick individual labels",
		labelsForModality: "For {modality}",
		labelsAll: "All labels",
		labelsOther: "Other modalities",
		labelNameHint: "Label name, e.g. LV scar",
		labelCodeHint: "The code is the permanent key — strokes, agreement scores and exports are all matched on it. Derived from the name; edit it only if you need a specific one.",
		cancel: "Cancel",
		create: "Create",
	},
	imagingWs: {
		size: "Size",
		title: "Imaging workspace",
		subtitle: "COCHE Tier-B — studies · upload · AI segmentation jobs · annotation tasks",
		noProject: "No project selected — open this page from a project, or add ?projectId= to the URL.",
		reload: "Reload",
		upload: "Upload",
		purge: "Purge project imaging data",
		analysisCsv: "Analysis CSV",
		toAnalytics: "→ Analytics dataset",
		toAnalyticsDone: "{rows} structure rows registered as dataset imaging_features v{version}",
		cpuOnly: "CPU only",
		gpuNotDefault: "A GPU node is configured but not on the automatic path; choose it in the AI segment dialog to use it.",
		gpuUnreachable: "No GPU node is answering; segmentation runs on this machine.",
		stageGpu: "Stage volumes to GPU node",
		stageGpuN: "GPU staging {staged}/{total}",
		stageStarted: "Staging job #{id} started for {n} volumes",
		purgeConfirm: "Delete EVERY study, series, annotation and task of this project's imaging module? This is irreversible.",
		purged: "Purged {n} series",
		tabStudies: "Studies",
		tabJobs: "Jobs",
		tabTasks: "Annotation tasks",
		patient: "Patient",
		date: "Date",
		modality: "Modality",
		description: "Description",
		seriesCount: "Series",
		instances: "Files",
		instancesHint: "DICOM SOP instances = files. A cine loop or a segmentation object is one instance holding many frames.",
		series: "Series",
		frames: "Frames",
		kind: "Kind",
		extent: "Extent",
		role: "Role",
		annotations: "Layers",
		actions: "Actions",
		openViewer: "Open viewer",
		delete: "Delete",
		deleted: "Deleted",
		deleteConfirm: "Delete \"{name}\"? This cannot be undone.",
		uploadTitle: "Upload imaging (DICOM / NIfTI / images)",
		uploadDrop: "Drop a folder, zip or files here — or click to select files",
		uploadHint: "DICOM of any size: folders, zips and DICOMDIR exports (index, report and RT-structure files are skipped), enhanced multi-frame MR / CT, plus NIfTI, MP4 / AVI and PNG / JPEG. Sent in 16 MB parts; patient identifiers are removed on ingest.",
		uploading: "Uploading",
		uploadProgress: "{sent} of {total} · {rate}/s",
		uploadPart: "part {n} of {m} · 16 MB parts, each retried up to 3 times",
		uploadRetry: "{n} retried",
		uploadCancel: "Cancel upload",
		uploadCancelled: "Upload cancelled",
		etaMeasuring: "measuring speed…",
		etaSoon: "under a minute left",
		etaMinutes: "about {n} min left",
		ingestSummary: "{accepted} accepted · {skipped} skipped · {duplicate} already on the platform · {rejected} rejected",
		chooseFolder: "Choose folder…",
		patientNoOpt: "Patient no. (optional)",
		modalityOpt: "Modality (non-DICOM)",
		modalityHint: "DICOM states its own modality. NIfTI, video and image files do not — without a declaration they are filed as \"other\", and AI segmentation is refused rather than guessing a model.",
		files: "files",
		clear: "Clear",
		startUpload: "Start upload",
		close: "Close",
		job: "Job",
		file: "File",
		bytes: "Size",
		status: "Status",
		reason: "Reason",
		backend: "Backend",
		progress: "Progress",
		createdBy: "Created by",
		started: "Started",
		duration: "Duration",
		error: "Error / result",
		jobStarted: "Job #{id} started on {backend}",
		segmentTask: "Task",
		cancel: "Cancel",
		newTask: "New annotation task",
		taskTitle: "Title",
		readers: "Readers",
		adjudicator: "Adjudicator",
		threshold: "Dice threshold",
		labels: "Labels",
		assigneesHint: "Comma-separated user names, e.g. coche_researcher, coche_admin",
		create: "Create",
		created: "Task created — one draft layer per reader",
		open: "Open",
		adjudicate: "Adjudicate",
		adjudicationTitle: "Adjudication",
		gold: "Gold",
		needTwoReaders: "This task needs two reader layers to adjudicate.",
		readerA: "Reader A",
		readerB: "Reader B",
		diff: "Difference",
		agree: "agree",
		only: "only",
		jumpAnnotated: "Jump to annotated frame",
		perLabelDice: "Per-label agreement",
		raters: "raters",
		panelAgreement: "Panel agreement",
		rater: "Reader",
		vsOthers: "Dice vs others",
		acceptConsensus: "Accept consensus of {n} as gold",
		consensusHint: "Majority vote: a voxel is kept when more than half the readers labelled it.",
		tabReaders: "Readers",
		readerStats: "Reader performance",
		readerStatsHint: "Derived from the layers, tasks and edit log — no separate bookkeeping.",
		statLayers: "Layers",
		statTasks: "Tasks",
		statSubmitted: "Submitted",
		statGold: "Chosen as gold",
		statGoldRate: "Gold rate",
		statEdits: "Edits",
		statDice: "Mean Dice vs others",
		statMinutes: "Median min. to submit",
		outcome: "Outcome",
		accepted: "accepted",
		duplicateN: "duplicate",
		skippedN: "skipped",
		rejectedN: "rejected",
		alreadyHere: "Already here as:",
		history: "History",
		historyTitle: "Layer history",
		historyEvents: "Edits",
		historyNone: "No edits recorded for this layer yet.",
		historyFrom: "Edited from layer",
		historyDecision: "Adjudication",
		staleLayer: "This layer changed while you were drawing — reloading it. Your last stroke was not saved.",
		decision: "Decision",
		noteOpt: "Note (optional)",
		acceptA: "Accept A as gold",
		acceptB: "Accept B as gold",
		editA: "Edit A → gold",
		editB: "Edit B → gold",
		notDisputed: "Task is {status} — decisions are only possible while disputed.",
		notAdjudicator: "Only the adjudicator ({user}) can decide this task.",
		adjudicated: "Adjudicated",
		goldLayer: "Gold layer",
		openInViewer: "Open in viewer",
	},
	ml: {
		title: "Federated learning & model registry",
		subtitle: "Flower FedAvg across sites — only model weights cross the wire; no patient rows leave a site",
		taskTitle: "What is being trained",
		taskHint: "The shared model — the only thing that crosses the wire",
		outcome: "Outcome",
		outcomeLabel: "3-year major adverse cardiac event (MACE), binary",
		modelFamily: "Model",
		modelLabel: "Logistic regression, aggregated across sites by FedAvg",
		parameters: "Parameters",
		coefPlural: "coefficients",
		cohort: "Cohort per site",
		cohortLabel: "{n} patients, generated at each site from its own seed and never shared",
		variables: "Predictor variables",
		variable: "Variable",
		unit: "Unit",
		popDist: "Population mean ± SD",
		coefficient: "Global coefficient",
		oddsRatio: "OR per 1 SD",
		intercept: "Intercept",
		standardisation: "Variables are z-scored against fixed population constants, not per-site statistics, so coefficients are directly comparable across sites.",
		finalModel: "final model",
		noCoef: "select a run below to see the learned coefficients",
		feat: {
			age: "Age",
			sbp: "Systolic blood pressure",
			ldl: "LDL cholesterol",
			hba1c: "HbA1c",
			smoking: "Current smoking",
			egfr: "eGFR",
		},
		reload: "Reload",
		startRun: "Start federated run",
		rounds: "rounds",
		minClients: "min sites",
		liveRun: "run in progress",
		runs: "Federated runs",
		noRuns: "No federated runs yet",
		status: "Status",
		roundsDone: "Rounds",
		sites: "Sites",
		waitingClients: "waiting for sites to connect…",
		bytes: "Bytes sent",
		auc: "AUC",
		loss: "Loss",
		started: "Started",
		runDetail: "Run detail",
		live: "live",
		rowsTransferred: "Rows transferred",
		wireTitle: "What crossed the wire",
		wireHint: "Every federated message in full — 7 float32 model weights, 28 bytes each, zero patient rows",
		wireValues: "Weights",
		wireHex: "Raw bytes",
		direction: "Direction",
		payload: "Payload",
		globalToSites: "global model → all sites",
		toServer: "→ server",
		site: "Site",
		city: "City",
		jurisdiction: "Jurisdiction",
		nSamples: "N",
		joinCommand: "Join command for a new site",
		copy: "Copy",
		copied: "Copied",
		chartTitle: "Per-site loss (solid) and global-model AUC (dashed) per round",
		round: "Round",
		models: "Model registry",
		noModels: "No registered models",
		name: "Name",
		version: "Version",
		algorithm: "Algorithm",
		artifactSha: "Artifact SHA-256",
		job: "Job",
		stage: "Stage",
		actions: "Actions",
		toStaging: "Stage",
		toProduction: "Promote to production",
	},
	timeseries: {
		title: "Physiological signals",
		streams: "Streams",
		viewer: "Viewer",
		reload: "Reload",
		live: "Live",
		ingestRate: "Ingest rate",
	},
	interop: {
		title: "FHIR / OMOP interoperability",
		framing: "FHIR R4 export layer / OMOP CDM v5.4 export — a HAPI FHIR server and an OHDSI ETL are the production deployment form.",
		coverage: "Mapping coverage",
		fields: "fields",
		mapped: "mapped",
		review: "review",
		unmapped: "unmapped",
		perModel: "Per model",
		model: "Model",
		conceptMap: "Concept map",
		field: "Field",
		target: "Target",
		resource: "Resource / table",
		element: "Element / column",
		vocabulary: "Vocabulary",
		code: "Code",
		conceptId: "OMOP concept_id",
		display: "Display",
		unit: "Unit",
		status: "Status",
		note: "Note",
		search: "Search field / code / display",
		save: "Save",
		cancel: "Cancel",
		edit: "Edit",
		saved: "Mapping saved",
		reseed: "Reset to seed",
		reseedConfirm: "Re-apply the shipped seed mapping? Manual edits will be overwritten.",
		lookup: "Value lookups",
		domain: "Domain",
		sourceValue: "Source value",
		fhir: "FHIR R4 bundle",
		patient: "Patient",
		pickPatient: "Select a patient",
		viewBundle: "View FHIR bundle",
		openRaw: "Open raw $everything",
		validate: "Validate project",
		validating: "Validating all patients…",
		resources: "Resources",
		valid: "valid",
		invalid: "invalid",
		bundleValid: "Bundle validates against fhir.resources R4B",
		bundleInvalid: "Bundle failed validation",
		omop: "OMOP CDM v5.4",
		download: "Download OMOP CDM (zip)",
		preview: "Preview tables",
		rows: "rows",
		table: "Table",
		reload: "Reload",
		loading: "Loading…",
		noProject: "Select a project first",
		collapseAll: "Collapse all",
		expandAll: "Expand all",
	},
	encryption: {
		title: "Encryption status",
		enabled: "Enabled",
		disabled: "Disabled",
		mysql: "MySQL",
		reload: "Reload",
		encryptAll: "Encrypt all",
		decryptAll: "Decrypt all",
	},
	header: {
		maskedHospital: "**** Hospital",
		systemAdminConsole: "System Admin Console",
		switchTenant: "Switch Tenant",
		configForm: "Configure Form",
		switchProject: "Switch Project",
		setPassword: "Set Password",
		changePassword: "Change Password",
		avatarSettings: "Avatar Settings",
		settings: "Settings",
		logout: "Sign out",
		oldPassword: "Old password",
		newPassword: "New password",
		confirmPassword: "Confirm password",
		enterOldPassword: "Please enter the old password",
		enterNewPassword: "Please enter the new password",
		enterConfirmPassword: "Please re-enter the new password",
		passwordMismatch: "Passwords do not match",
		tenantCodePrompt: "Enter tenant code (must be a valid tenant code)",
		passwordSetSuccess: "Password set. Please sign in again.",
		passwordChangeSuccess: "Password changed. Please sign in again.",
		compactMode: "Compact mode",
		compactModeDesc: "Form fields laid out horizontally with tighter line spacing",
		darkMode: "Dark mode",
		darkModeDesc: "Local-only; persists across reload",
		dataMasking: "Data masking",
		dataMaskingDesc: "Hide sensitive fields in lists/forms",
		fontTheme: "Font theme",
		fontThemeDesc: "Pick a modern type pairing for English and Chinese — local-only, applies instantly",
		fontThemeModern: "Modern",
		fontThemeEditorial: "Editorial",
		fontThemeFriendly: "Friendly",
		betaSuffix: " (BETA)",
		languageDesc: "Interface language; the page reloads when you switch",
		changePasswordDesc: "Update your sign-in password; you will be signed out after the change",
		avatarSettingsDesc: "Upload or replace your avatar image",
		modify: "Modify",
		displayName: "Display name",
		displayNameDesc: "The name shown across the app; your login username can't be changed",
		editDisplayName: "Edit display name",
		displayNamePlaceholder: "Enter a display name",
		displayNameRequired: "Please enter a display name",
		displayNameLength: "Display name must be 1–120 characters",
		displayNameUpdated: "Display name updated",
		sectionAccount: "Account",
		sectionAppearance: "Appearance",
		sectionPrivacy: "Privacy",
	},
	followup: {
		title: "Follow-ups",
		statTotalCase: "Total cases",
		statMonthlyDue: "Visits due this month",
		statMonthlyDone: "Visits completed this month",
		statMonthlyOpen: "Visits outstanding this month",
		searchDate: "Visit date:",
		searchStatus: "Status:",
		searchPatient: "Patient name / ID:",
		startDate: "Start",
		endDate: "End",
		select: "Select…",
		input: "Type here",
		searchBtn: "Search",
		resetBtn: "Reset",
		colIndex: "No.",
		colVisitPlan: "Visit plan",
		colPatientName: "Patient",
		colPatientNo: "Patient ID",
		colVisitDate: "Visit date",
		colVisitName: "Visit",
		colStatus: "Status",
		colCenter: "Centre",
		colOperation: "Actions",
		actEdit: "Edit",
		actView: "View",
		actCancel: "Cancel visit",
		statusPending: "Pending",
		statusOverdue: "Overdue",
		statusDone: "Done",
		fieldKeyword: "Type to search",
		detailTitle: "Follow-up detail",
	},
	multicenter: {
		overviewTitle: "Multi-centre overview",
		patientTitle: "Multi-centre patients",
		followupTitle: "Multi-centre follow-ups",
		colCenter: "Centre",
		colTenant: "Tenant",
		colPatientCount: "Patients",
		colFollowupCount: "Follow-ups",
		colCompleteness: "Completeness",
		switchProject: "Switch project",
		statCenters: "Centres",
		statPatients: "Total patients",
		statFollowups: "Total visits",
		statOverdue: "Overdue visits",
		newPatientTrend: "New patient trend",
		today: "Today",
		thisWeek: "This week",
		thisMonth: "This month",
		thisYear: "This year",
		startDate: "Start date",
		endDate: "End date",
		dateSep: "to",
		centerPatientCount: "Patients per centre",
		colRank: "Rank",
		colCenterName: "Centre",
		colUserCount: "Users",
		colPatientCountAlt: "Patients",
		patientGender: "Patient gender",
		mcInfo: "Multi-centre info",
		caseCount: "Cases",
		departmentCount: "Departments",
		mapCenters: "Centre map",
		mapPatients: "Patient distribution",
		caseFilter: "Filter by case count",
		all: "All",
		hospitalName: "Hospital:",
		departmentName: "Department:",
		projectName: "Project:",
		patientCountLabel: "Cases:",
		emptyData: "No data",
	},
	manage: {
		auditLog: "Audit log",
		piiRule: "PII rule config",
		governanceInbox: "Approval inbox",
		myRequests: "My requests",
		scopeTree: "Org chart",
		lifecycle: "Lifecycle",
		metadataVersioning: "Schema versions",
		ingestionHardening: "Ingestion guard",
		ehealth: "eHealth upload",
		subCenter: "Sub-centres",
		schema: "Schema gen",
		agentConfig: "Agent config",
		random: "Randomisation",
		consent: "Consent forms",
	},
	databaseConfig: {
		patientBasicInfo: "Patient basic info",
		databaseSection: "Database configuration",
		followupSection: "Follow-up forms",
		colNo: "No.",
		colFormCode: "Form code",
		colFormName: "Form name",
		colModelCount: "Models",
		colOp: "Actions",
		colFollowupCode: "Follow-up form code",
		colFollowupName: "Follow-up form name",
		colFollowupPlan: "Linked follow-up plan",
		colFollowupPlanName: "Linked plan name",
		btnAdd: "Add",
		btnBatchAdd: "Batch add",
		btnDelete: "Delete",
		btnEdit: "Edit",
		btnConfig: "Configure",
		btnConfigFromTemplate: "From template",
		btnConfigFromForm: "From project form",
		dlgEditTitle: "Edit",
		dlgAddTitle: "Add",
		dlgEditFollowupTitle: "Edit follow-up form",
		dlgAddFollowupTitle: "Add follow-up form",
		dlgFormName: "Form name",
		dlgFollowupName: "Follow-up form name",
		dlgPh: "Please enter",
		dlgCancel: "Cancel",
		dlgConfirm: "Confirm",
	},
	memberPermissions: {
		title: "Members & permissions",
		colNo: "No.",
		colTenant: "Tenant",
		colUsername: "Username",
		colNickname: "Nickname",
		colFuncPermission: "Function permission",
		colDataPermission: "Data permission",
		colActions: "Actions",
		btnConfigure: "Configure",
		btnEdit: "Edit",
		noRolesAssigned: "(no roles)",
		scopeCount: "Scope: {f} form(s) · {m} model(s)",
		actEditRoles: "Edit function permission",
		actEditData: "Edit data permission",
		actRemove: "Remove",
		confirmRemove: "Remove this user from the project?",
		dlgAddTitle: "Add member",
		addHint: "Search by exact username, employee number, or mobile to add a member. Set function and data permissions afterwards.",
		searchPh: "Type exact username / employee no / mobile…",
		searchNoMatch: "No matching user — check spelling or use exact ID",
		lblAccount: "Account",
		btnAddAnother: "Add another",
		dlgFuncTitle: "Function permission",
		projectRolesLabel: "Project-scoped roles (managed here)",
		globalRolesLabel: "Globally-effective roles (managed in user admin)",
		globalRolesHint: "These roles are assigned at the user level and apply to every project. Edit them in the user admin page, not here.",
		projectRolesEmptyButGlobal: "No project-scoped roles assigned. This user's effective permissions on this project come entirely from the global roles above. Add a role here to give them additional permissions scoped to this project only.",
		projectRolesEmptyNoGlobal: "No roles assigned to this user yet. Pick one or more above to grant project-scoped access.",
		dlgDataTitle: "Data permission",
		dataBypassModelAdmin: "Heads-up: this user has the Model Administrator role and bypasses the data-permission filter entirely. The selections below are saved but have no effect at view time — they only apply to users without Model Administrator.",
		dataBypassProjectCreator: "Heads-up: this user is the project creator and bypasses the data-permission filter entirely. The selections below are saved but have no effect at view time — project creators always see all forms and models.",
		sodWarnTitle: "Separation-of-duties warning ({n} conflicts) — you may still save",
		sodErrorTitle: "Separation-of-duties violation ({n} conflicts) — enforce mode is on, save blocked",
		sodEnforceBlocked: "Separation-of-duties violation — remove the conflicting roles before saving",
		sodWarnSaved: "Saved with {n} separation-of-duties warning(s)",
	},
	sod: {
		tagPending: " (pending)",
		tagAssigned: " (assigned)",
		violationLine: "{a} conflicts with {b} ({classA} × {classB})",
	},
	scopeTree: {
		filterTenantPh: "Filter by tenant code",
		visibilityTitle: "My scope visibility",
		visibilityPrompt: "Click Reload to query the current session's visible project set.",
		fUserId: "User ID",
		fBypass: "Bypass filter",
		bypassYes: "Yes (bypass)",
		bypassNo: "No (enforced)",
		fReason: "Reason",
		fScopePaths: "Scope paths",
		noScopePath: "— no scope_path assigned —",
		fAllowedProjects: "Visible project IDs",
		bypassAll: "— bypass: all visible —",
		noVisibleProject: "No visible projects (allowed-set is empty)",
		emptyTree: "No organisation data yet",
		rootLabel: "All organisations",
		tagDefault: "Default",
		tagProjectCount: "{n} project(s)",
		truncated: "Results truncated (>1000 nodes). Use the per-level endpoint to paginate.",
		selectHint: "Select a node on the left to view its details.",
		dKind: "Level",
		dCode: "Code",
		dTenant: "Tenant",
		dRegulatory: "Regulatory jurisdiction",
		dFederation: "Federation mode",
		dAddress: "Address",
		dCountry: "Country",
		dRegion: "Region",
		dMission: "Mission",
		dProjectCount: "Projects",
	},
	auditLog: {
		title: "Audit log",
		refresh: "Refresh",
		startDate: "From",
		endDate: "To",
		category: "Category",
		verb: "Verb",
		targetType: "Target type",
		outcome: "Outcome",
		actorUserId: "Actor ID",
		dataSubjectId: "Data subject ID (GDPR)",
		targetProjectCode: "Project code",
		search: "Search",
		reset: "Reset",
		empty: "No audit logs",
		colTime: "Time",
		colActor: "Actor",
		colApp: "Source",
		colCategory: "Category",
		colVerb: "Verb",
		colTarget: "Target",
		colOutcome: "Outcome",
		colDetail: "Detail",
		view: "View",
		drawerTitle: "Audit log detail",
		eventSection: "Event",
		complianceSection: "Compliance metadata (GDPR readiness)",
		integritySection: "Integrity (hash chain)",
		fId: "ID",
		fTime: "Time",
		fActor: "Actor",
		fIp: "IP",
		fApp: "Source",
		fCategory: "Category / Verb",
		fOutcome: "Outcome",
		fFailureReason: "Failure reason",
		fTarget: "Target",
		fProject: "Project",
		fLawful: "lawful_basis",
		fSubject: "data_subject_id",
		fCrossBorder: "cross_border_transfer",
		yes: "Yes",
		no: "No",
		fDestCountry: "destination_country",
		fPrev: "prev_log_hash",
		fThis: "this_log_hash",
		changeRefSection: "Linked change record",
		loadChange: "Load change detail",
		fTable: "Table/Collection",
		fPk: "Primary key",
		fOp: "Op",
		loadChangeFailed: "Failed to load change detail",
	},
	metaVer: {
		intro: "Read-only view of <a href=\"/api/cmdb-template/doc.html#/cmdb-metadata\" target=\"_blank\">/cmdb-metadata</a>. Version/history snapshots roll out via spec §3's three-phase switches. See <code>extract/coche/specs/metadata-versioning.md</code>.",
		tabLog: "Evaluation log (shadow+exec)",
		tabTags: "Tags",
		tabAdapters: "Format adapters",
		colTarget: "Target",
		colPriorVer: "Prior ver.",
		colNote: "Note",
		colCode: "Code",
		colTag: "Tag",
		colDescription: "Description",
		colCreated: "Created",
		colExtensions: "Extensions",
		colName: "Name",
		colEnabled: "Enabled",
		on: "On",
		off: "Off",
	},
	lifecyclePage: {
		intro: "Read-only view of <a href=\"/api/cmdb-template/doc.html#/cmdb-lifecycle\" target=\"_blank\">/cmdb-lifecycle</a>. Policies and legal holds are created via the API; execution flows through the approval workflow (§10.1.3). See <code>extract/coche/specs/lifecycle-retention.md</code>.",
		tabPolicies: "Retention policies",
		tabHolds: "Legal holds",
		tabLog: "Evaluation log (shadow+exec)",
		colTargetType: "Target type",
		colRetentionDays: "Retention (d)",
		colAgeAnchor: "Age anchor",
		colAction: "Action",
		colEnabled: "Enabled",
		colDescription: "Description",
		on: "On",
		off: "Off",
		colScope: "Scope",
		colTargetId: "Target ID",
		colReason: "Reason",
		colImposed: "Imposed",
		colReleased: "Released",
		active: "Active",
		colAgeDays: "Age (d)",
		colRequest: "Request",
		colNote: "Note",
	},
	dataSync: {
		title: "Daily data updates",
		reload: "Reload",
		range7d: "7 days",
		range30d: "30 days",
		range90d: "90 days",
		todayNewPatients: "New patients today",
		todayUnits: "Follow-up units today",
		last7d: "Last 7 days",
		backlog: "Backlog units",
		backlogHint: "Enumerated but not yet written",
		latestRun: "Latest run",
		noRuns: "No runs yet",
		noData: "No data",
		chartTitle: "Daily update trend",
		seriesUnits: "Follow-up units",
		seriesPatients: "New patients",
		seriesErrors: "Errors",
		runHistory: "Run history",
		colBatch: "Batch",
		colPhase: "Phase",
		colStatus: "Status",
		colStarted: "Started",
		colEnded: "Ended",
		colDone: "Done",
		colSkip: "Skipped",
		colEmpty: "Empty",
		colErrors: "Errors",
		colNewPatients: "New patients",
		colDocuments: "Documents",
		colNote: "Note",
		detailTitle: "Run detail",
		cacheHits: "cache hits",
		unrouted: "Unrouted examination items",
		unmappedEnums: "Unmapped enum values",
		unmappedEnumValues: "Dropped enum values",
		enumSynonym: "Matched via synonym",
		enumCatchAll: "Bucketed as catch-all",
		unknownModels: "Unknown models",
		multiRecordDropped: "Multi-record data dropped",
		activeFilterSkipped: "Active-row filter skipped",
		numericPercent: "Numeric: percent sign stripped",
		numericDecimal: "Numeric: decimal in an integer field",
		numericThreshold: "Numeric: threshold value refused",
		numericUnit: "Numeric: value with unit refused",
		numericList: "Numeric: multi-value refused",
		numericQualitative: "Numeric: qualitative answer refused",
		numericThresholdValue: "Numeric: threshold values",
		numericUnitValue: "Numeric: values with units",
		numericListValue: "Numeric: multi-values",
		numericQualitativeValue: "Numeric: qualitative answers",
		groupTruncated: "{n} more not shown",
		scalars: "Other counters",
		colItem: "Item",
		colCount: "Count",
		status: {
			running: "Running",
			completed: "Completed",
			aborted: "Aborted",
			failed: "Failed",
		},
	},
	ehealth: {
		uploadReport: "Upload Inbox report (PDF)",
		uploadReportHint: "Process Summary / Exception / Re-grade printed from the eHR Inbox. Image-only PDFs are OCR'd (~30 s).",
		reportDone: "{kind} · {state} · {batches} batch(es), {records} record(s) matched",
		reportKind: "Kind",
		reportTitle: "Title",
		issuedAt: "Issued",
		parseState: "Read",
		matchedBatches: "Batches",
		matchedRecords: "Records",
		lines: "Lines",
		reconcile: "Re-reconcile",
		noReports: "No reports uploaded yet.",
		errorCode: "Error code",
		errorField: "Field",
		rawLine: "As read",
		tabNotifications: "Notifications",
		poll: "Poll eHealth (GPNH)",
		pollHint: "Outbound: fetches consent / key-change / death notifications since the last window and applies them. 24/7.",
		pollDone: "Poll done: {received} received, {applied} applied, {duplicates} duplicates, {unmatched} for unknown patients",
		pendingRepliesTitle: "{n} consent notification(s) still owed a major-key-match reply (7-day clock)",
		colEvent: "Event",
		changes: "Applied changes",
		reply: "Reply",
		replyDue: "due by",
		previewMatch: "Preview match",
		sendReply: "Send reply",
		noReplyDue: "no reply due",
		noNotifications: "No notifications applied yet.",
		scan: "Scan records",
		scanHint: "Registers the project's LABGEN records (new, amended, withdrawn). Local only.",
		scanDone: "Scan done: {scanned} scanned, {registered} registered, {amended} amended, {withdrawn} withdrawn",
		transactions: "Transactions",
		txnDatetime: "Transaction datetime",
		outcome: "Outcome",
		rows: "Emitted rows",
		build: "Build batch",
		buildHint: "Assembles pending records into a signed, encrypted LABGEN batch on disk. Nothing leaves until Upload.",
		buildDone: "Built {name} ({mode}): {included} record(s) included, {excluded} excluded",
		modeAuto: "Mode: automatic",
		noBatches: "No batches built yet.",
		colBatchName: "Batch (HL7 name)",
		colParticipants: "Patients",
		colNotes: "Build notes",
		actions: "Actions",
		files: "Files",
		upload: "Upload (SFTP)",
		checkCollected: "Collected?",
		uploadDone: "Uploaded — records are now DEPOSITED, awaiting a report",
		remoteDir: "Remote folder",
		zipSha: "Zip SHA-256",
		fileKind: "Kind",
		fileName: "File",
		bytes: "Bytes",
		checksum: "SHA-256",
		open: "Open",
		record: "Record",
		refresh: "Refresh",
		colName: "Name",
		colDob: "DOB",
		colSex: "Sex",
		colConsent: "Consent",
		colFlags: "Flags",
		colQuery: "Last PMI Query",
		colEligibleFrom: "Eligible from",
		unknown: "unknown",
		flagDeceased: "deceased",
		flagSuspended: "suspended",
		flagProblem: "problem record",
		neverQueried: "never queried",
		pmiSync: "Sync from patient profiles",
		pmiSyncHint: "Re-derives the PMI identity rows from the Patient Profile form. Local only.",
		pmiSyncDone: "Sync done: {scanned} scanned, {created} created, {updated} updated, {unchanged} unchanged",
		pmiEmpty: "No PMI rows yet — add patients on the Patient Profile form, then sync.",
		majorKeys: "Major keys",
		lastDeposit: "Last deposit",
		documents: "Identity documents",
		docType: "Type",
		docNumber: "Number",
		docNumberNorm: "Normalised",
		docValidity: "Validity",
		docCurrent: "current",
		docSuperseded: "superseded",
		eligibility: "Deposit eligibility",
		eligibleYes: "Eligible",
		eligibleNo: "Not eligible",
		eligibilityNote: "Computed now from live state and the last PMI Query within its freshness bound. Never a stored flag.",
		recordDecision: "Record decision",
		pmiQuery: "Ask eHealth (PMI Query)",
		pmiQueryHint: "Outbound call through the HK egress; eHealth answers weekdays 08:00–18:00 HKT only.",
		pmiQueryDone: "PMI Query completed",
		keyHistory: "Superseded major keys",
		supersededAt: "Superseded at",
		surname: "Surname",
		givenName: "Given name",
		reason: {
			OK_JOINING_CONSENT: "joining consent confirmed by eHealth",
			NO_EHR_NUMBER: "eHealth holds no participant for these keys",
			DECEASED: "patient recorded as deceased",
			CONSENT_REVOKED: "consent to this provider was revoked",
			EMERGENCY_ONLY: "emergency access only (viewer, no deposit)",
			QUERY_STALE: "last PMI Query is older than the freshness bound — re-query",
			QUERY_UNAVAILABLE: "no usable PMI Query result yet — query eHealth",
		},
		intro: "Clinical data upload to the Hong Kong eHealth System (eHRSS). Deposit is a batch channel, not a per-save API: records are held here, packaged per domain, signed and deposited over SFTP, and judged asynchronously by a report that arrives afterwards. A collected batch is NOT an accepted batch.",
		tabRecords: "Records",
		tabBatches: "Batches",
		tabPatients: "PMI patients",
		tabRegister: "Clinical record register",
		registerAllDomains: "All data domains",
		registerHint: "Every record this system holds, per patient, with the batch that carried it to eHealth.",
		registerEmpty: "No clinical records held for this project yet.",
		registerFootnote:
			"Records are created in this system before deposit and carry the batch that uploaded them, evidencing that clinical data reaches eHealth programmatically rather than by manual entry.",
		cntPatients: "Patients",
		cntRecords: "Clinical records",
		cntUploaded: "Uploaded to eHealth",
		cntDomains: "Data domains",
		colSummary: "Record",
		colRecordDate: "Record date",
		colCreatedInEmr: "Created in EMR",
		colUploaded: "Uploaded",
		tabReports: "Reports",
		tabMapping: "Field mapping",
		colRecordKey: "Record key",
		colDomain: "Domain",
		colPatient: "Patient",
		colEhrNumber: "eHR number",
		colTxn: "Txn",
		colState: "State",
		colCreated: "Created in EMR",
		colDeposited: "Deposited",
		colBatch: "Batch",
		colLevel: "Level assigned",
		colMode: "Mode",
		colTransport: "Transport",
		colGenerated: "Generated",
		colRecordCount: "Records",
		stateHeld: "Held",
		stateDeposited: "Deposited",
		stateAccepted: "Accepted",
		stateRejected: "Rejected",
		stateRegraded: "Re-graded",
		stateWithdrawn: "Withdrawn",
		depositPending: "Awaiting a report — deposit is not acceptance",
		notConfigured: "This project has no eHealth deposit target (ehealth_hcp_id is not set), so records can be reviewed here but never deposited.",
		disabledGlobally: "The eHealth feature is switched off on this deployment (imles.ehealth.enabled=false).",
		shadowMode: "Shadow mode — batches are built and recorded but never transmitted.",
		empty: "No eHealth records held for this project yet.",
	},
	ingestion: {
		intro: "Read-only view. Ingestion hardening rolls out via spec §3's three-phase switches (Phase A=dormant / Phase B=shadow / Phase C=enforce). SFTP server is independently gated by <code>imles.ingestion.sftp.enabled</code>. See <code>extract/coche/specs/ingestion-hardening.md</code>.",
		tabChecksum: "Checksum (SHA-256)",
		tabRejections: "Rejection queue",
		tabDedup: "Dedup table",
		tabSftp: "SFTP sessions",
		hashPlaceholder: "Look up by SHA-256 (64 hex)",
		colOssFile: "OSS file",
		colBytes: "Bytes",
		colSource: "Source",
		colUploaded: "Uploaded",
		colFilename: "Filename",
		colReason: "Reason",
		colMode: "Mode",
		colDetail: "Detail",
		colOriginFileId: "Origin file ID",
		colReuseCount: "Reuse count",
		colFirstSeen: "First seen",
		colLastReuse: "Last reuse",
		colUser: "User",
		colAuth: "Auth",
		colOpened: "Opened",
		colClosed: "Closed",
		colUploads: "Uploads",
		colTotalBytes: "Total bytes",
		colCloseReason: "Close reason",
	},
	dbConfig: {
		title: "Database config",
		step1: "Select database model",
		step2: "Select output type",
		step3: "Configure form/document",
		step4: "Configure fields",
		selectedOutput: "Selected output type",
		structuredForm: "Structured form",
		structuredF1: "· Export data with custom forms",
		advFilter: "· Advanced filtering supported",
		univariate: "· Univariate statistical analysis supported",
		crfExport: "· Generate CRF tables from data, export as PDF/Word",
		defaultForm: "Default form",
		defaultF1: "· Display the form with its default structure",
		formConfigTitle: "Project form config",
		formName: "Project form name",
		formCode: "Project form code",
		formOrder: "Project form order",
		visible: "Visible",
		formModelConfigTitle: "Project form model config",
		selectModel: "Select model",
		newModel: "New model",
		colIndex: "No.",
		modelCode: "Model code",
		modelName: "Model name",
		modelDomain: "Model domain",
		modelOrder: "Model order",
		modelConfigTitle: "Project model config",
		modelNameLabel: "Project model name",
		modelCodeLabel: "*Project model code",
		modelCodeLabelReq: "Project model code",
		dontModify: "Do not modify unless necessary",
		deletionMode: "Deletion mode",
		logical: "Logical",
		physical: "Physical",
		modelDescription: "Model description",
		showNoteInput: "Show note input",
		note: "Note",
		sceneType: "Scene type",
		sceneDefault: "Default scene",
		sceneTable: "Table scene",
		sceneTableDialog: "Table dialog scene",
		sceneList: "List scene",
		uploadAttachment: "Upload attachment",
		on: "On",
		off: "Off",
		saveModelAttrs: "Save model attributes",
		editFields: "Edit fields",
		modelFieldConfigTitle: "Project model field config",
		previous: "Previous",
		next: "Next",
		selectedInfo: "Selected info",
		availableInfo: "Available info",
		codeFormatHint: "Enter letters, digits or underscores",
		selectRowFirst: "Select a row before adding",
		enterModelName: "Enter the project model name",
		enterModelCode: "Enter the project model code",
		modelCodeFormat: "Model code may only contain letters, digits and underscores",
		saveFormFirst: "Save the form info first",
		modelCodeExists: "This model code already exists",
	},
	fieldList: {
		colFieldOrder: "Field order",
		colIntegrityScore: "Integrity score",
		colFieldCode: "Field code",
		colFieldName: "Field name",
		colFieldType: "Field type",
		colVisible: "Visible",
		colEditable: "Editable",
		colRequired: "Required",
		colDictValue: "Dictionary value",
		addField: "Add field",
		refField: "Reference field",
		dlgEdit: "Edit",
		dlgAdd: "Add",
		order: "Order",
		noSorting: "No sorting",
		reservedHint: "The following field codes have special meaning and are auto-mapped to the patient info table:",
		colMeaning: "Meaning",
		colDescription: "Description",
		reservedUniqueNote: "<b>card_id</b>, <b>inpatient_id</b> and <b>outpatient_id</b> have a uniqueness constraint — duplicate values are not allowed within the same project, which helps prevent duplicate patient entry.",
		fieldNameZh: "Field name (Chinese)",
		fieldNameEn: "Field name (English)",
		fieldAlias: "Field alias",
		tailLabel: "Tail label",
		refRange: "Reference range",
		refMin: "Min",
		refMax: "Max",
		refRangeHint: "Numeric types only; out-of-range values are flagged abnormal, not blocked",
		refRangeInvalid: "Reference range min cannot exceed max",
		fieldDesc: "Field description",
		controlsVisibility: "Controls visibility",
		controlledFields: "Controlled fields",
		optionCode: "Option code",
		optionName: "Option name",
		controlledFieldCount: "Controlled field count",
		controlledModelCount: "Controlled model count",
		inFormEvent: "In-form event",
		inModelEvent: "In-model event",
		inModelClickEvent: "In-model click event",
		showNoteInput: "Show note input",
		note: "Note",
		subFieldList: "Sub-field list",
		refList: "Reference list",
		selectExisting: "Select existing field",
		colIndex: "No.",
		colModifiedBy: "Modified by",
		colModifiedAt: "Modified at",
		dlgSubEdit: "Edit sub-field",
		dlgSubAdd: "Add sub-field",
		existingFieldList: "Existing field list",
		fieldControlled: "Field-controlled",
		modelControlled: "Model-controlled",
		colFieldId: "Field ID",
		colModelId: "Model ID",
		colModelCode: "Model code",
		colModelName: "Model name",
		refSaved: "Reference relationship saved",
		convertedToSub: "Converted to sub-field",
		none: "None",
		reserved: {
			name: { n: "Name", d: "Patient name" },
			gender: { n: "Gender", d: "0=Female, 1=Male" },
			age: { n: "Age", d: "Patient age" },
			birthday: { n: "Date of birth", d: "Patient birthday" },
			phone: { n: "Mobile", d: "Contact phone" },
			idNum: { n: "ID number", d: "National ID number" },
			cardId: { n: "Admission card no.", d: "Unique constraint, no duplicates" },
			inpatientId: { n: "Outpatient no.", d: "Unique constraint, no duplicates" },
			outpatientId: { n: "Inpatient no.", d: "Unique constraint, no duplicates" },
			admissionTime: { n: "Admission time", d: "Date type" },
			enrollmentTime: { n: "Enrollment time", d: "Date type" },
			diagnosis: { n: "Diagnosis", d: "Diagnosis info" },
			doctorId: { n: "Doctor ID", d: "Linked doctor" },
			doctorName: { n: "Doctor name", d: "Linked doctor name" },
			hospitalName: { n: "Hospital", d: "Hospital name" },
			status: { n: "Patient status", d: "e.g. enrolled, withdrawn" },
			statusCode: { n: "Status code", d: "Code for the status" },
		},
	},
	customColumn: {
		title: "Custom columns",
		searchFieldPh: "Search field name",
		name: "Name",
		order: "Order",
		visible: "Visible",
		description: "Description",
		propertyPath: "Property path",
		selectProperty: "Please select a property",
		colIndex: "No.",
	},
	piiRule: {
		title: "PII rule config",
		currentProject: "Current project",
		refresh: "Refresh",
		readonly: "Read-side anonymisation",
		readonlyDesc: "Rules only apply on data export and cohort search paths; stored data is untouched. KEEP returns the raw value. Roles with the pii.unmask permission can bypass (bypass is audited).",
		addRule: "Add rule",
		preview: "Preview rules",
		saveAll: "Save all changes",
		empty: "No PII rules configured yet",
		colField: "Field code",
		colMode: "Mode",
		colExample: "Example",
		colNote: "Note",
		colOperation: "Actions",
		actDelete: "Delete",
		modeKeep: "Keep raw value (default)",
		modeMask: "Mask",
		modeRedact: "Placeholder",
		modePseudonym: "Project-deterministic pseudonym",
		modeHash: "SHA-256 hash (12 hex)",
		modeSuppress: "Suppress field",
		modeGeneralise: "Bucket / generalise",
		previewMissingInput: "Please fill in field and mode.",
		draftMissingFieldCode: "New rules must have a field code.",
		saveSummary: "Saved {saved} · deleted {deleted}",
	},
	analytics: {
		overviewTitle: "Analytics overview",
		datasetTitle: "Datasets",
		encodingTitle: "Field encoding",
		selectionTitle: "Field selection",
		algorithmTitle: "Algorithm runs",
		reportTitle: "Statistical report",
		researchOverviewTitle: "Research overview",
		libraryTitle: "Library",
		topicsTitle: "Topic recommendations",
		workbenchTitle: "Workbench",
		refresh: "Refresh",
		empty: "No analytics data yet",
		statSamples: "Samples",
		statFields: "Fields",
		statAnalyses: "Analyses",
		recentAnalyses: "Recent analyses",
		colName: "Name",
		colType: "Type",
		colCreatedAt: "Created",
		colOperation: "Actions",
		actView: "View",
		viewDetail: "View details",
		typeAlgorithm: "Algorithm",
		typeReport: "Report",
		errorProject: "Project not found",
		errorFetch: "Failed to load data",
		topics: {
			rescoreBtn: "Re-score with latest data",
			runDiscovery: "Run discovery",
			rediscoverForce: "Re-run discovery (ignore processed)",
			searchPlaceholder: "Search topics...",
			sourceDocPlaceholder: "Source document",
			variantTypePlaceholder: "Type",
			variant: {
				guidanceExtraction: "Guideline extraction",
				subgroup: "Subgroup analysis",
				combination: "Combination therapy",
				methodology: "Methodology",
				validation: "Validation study",
				novelAssociation: "Novel association",
				endpoint: "Endpoint analysis",
				uncategorised: "Uncategorised",
			},
			status: {
				proposed: "Pending review",
				approved: "Approved",
				rejected: "Rejected",
				deferred: "Deferred",
				exploredNull: "Explored · no significant finding",
			},
			foundTopics: "Found {n} new topics",
			initialising: "Initialising...",
			recommendTitle: "Data-ready recommendations",
			recommendSub: "Scored against this project's actual data completeness — the topics below can be analysed with existing data",
			dataReadyPct: "Data ready {n}%",
			retrospectiveFeasible: "Retrospective feasible",
			needProspective: "Prospective data needed",
			startResearch: "Start research analysis",
			emptyTopics: "No recommended topics yet",
			runTopicDiscovery: "Run topic discovery",
			compositeScore: "Composite score",
			scoreComposite: "Composite",
			feasibilityScore: "Feasibility score",
			scoreFeasible: "Feasible",
			dataCompleteness: "Data completeness",
			scoreData: "Data",
			relevanceHigh: "Highly relevant",
			relevanceNormal: "Relevant",
			noRelatedLiterature: "No highly relevant literature found",
			novelty: {
				wellCovered: "Heavily covered in the literature",
				partiallyCovered: "Similar studies exist",
				novel: "Good novelty",
			},
			label: {
				studyDesign: "Study design:",
				primaryEndpoint: "Primary endpoint:",
				dataFeasibility: "Data feasibility:",
				requiredFields: "Required fields:",
				prospectiveNeeds: "Additional collection needed:",
				analysisPath: "Analysis approach:",
				suggestedAngle: "Suggested differentiating angle:",
				sourceDocs: "Source documents:",
			},
			dataReadyFields: "Data ready {matched}/{total} fields",
			fieldMissingMark: "· missing",
			docCount: "{n} documents",
			downloadPdf: "Download PDF",
			docNotFound: "Document not found",
			viewSourceLink: "View source",
			docType: {
				guidance: "Guideline",
				research: "Research paper",
				clinicalTrial: "Clinical trial",
				reference: "Reference document",
			},
			approve: "Approve",
			defer: "Defer",
			reject: "Reject",
			editAndApprove: "Edit then approve",
			editDialogTitle: "Edit topic",
			form: {
				titleCn: "Topic title",
				titleEn: "English title",
				studyDesign: "Study design",
				primaryEndpoint: "Primary endpoint",
				hypothesis: "Hypothesis",
				notes: "Notes",
				notesPlaceholder: "Additional research notes",
			},
			saveAndApprove: "Save and approve",
			fieldMatched: "Matched database field: {field}",
			fieldUnavailable: "Not in the database yet — needs additional collection",
			fieldSample: "Samples: {n}",
			msg: {
				downloadFailed: "Download failed",
				noProfile: "No data profile yet. Generate one first under Research material → Datasets.",
				rescoreDone: "Re-scored {n} topics against the latest data; {ready} are data ready",
				rescoreFailed: "Re-scoring failed",
				approveFailed: "Failed to approve the topic. Please try again.",
				projectNotFound: "Project not found",
				discoveryStarted: "Topic discovery started",
				discoveryStartFailed: "Failed to start discovery",
				discoveryDone: "Discovery complete: {n} new topics",
				discoveryFailed: "Discovery failed: {error}",
				unknownError: "Unknown error",
				confirmReject: "Reject this topic?",
				approved: "Topic approved. Tap Start research analysis to enter the research flow.",
				rejected: "Topic rejected",
				deferred: "Topic deferred",
				editedApproved: "Topic edited and approved. Tap Start research analysis to enter the research flow.",
				sessionCreated: "Research session created. Opening the workbench.",
				sessionCreateFailed: "Failed to create the research session",
			},
			design: {
				retrospectiveCohort: "Retrospective cohort study",
				prospectiveCohort: "Prospective cohort study",
				caseControl: "Case-control study",
				crossSectional: "Cross-sectional study",
				rct: "Randomised controlled trial",
				metaAnalysis: "Meta-analysis",
				survivalAnalysis: "Survival analysis",
				prognosticFactor: "Prognostic factor analysis",
				diagnosticAccuracy: "Diagnostic accuracy study",
				registryStudy: "Registry study",
				caseSeries: "Case series",
			},
			term: {
				crisisOccurrence: "Occurrence of myasthenic crisis",
				crisisIncidence: "Incidence of myasthenic crisis",
				myasthenicCrisis: "Myasthenic crisis",
				mgAdlTotal: "MG-ADL total score",
				qmgScore: "QMG score",
				mgQol15rScore: "MG-QOL15r score",
				mgfaClassification: "MGFA clinical classification",
				ossermanClassification: "Osserman classification",
				mse: "Minimal Symptom Expression (MSE)",
				mms: "Minimal Manifestation Status (MMS)",
				csr: "Complete Stable Remission (CSR)",
				atFollowUp: "at follow-up",
				at12MonthFollowUp: "at 12-month follow-up",
				baseline: "Baseline",
				duringFollowUp: "during follow-up",
				duringDiseaseCourse: "during the course of disease",
				achievementOf: "Achievement of",
				associationBetween: "Association between",
				neckMuscleStrength: "neck muscle strength",
				thyroidFunction: "thyroid function",
				autoantibody: "autoantibody",
				serumCreatinine: "serum creatinine",
				urea: "urea",
				smoking: "smoking",
				and: "and",
			},
		},
		library: {
			tabDataset: "Datasets",
			tabGuidance: "Guidelines",
			tabResearch: "Research literature",
			tabReference: "Reference files",
			modeNew: "New dataset",
			modeVersion: "New version",
			uploadDataset: "Upload dataset",
			generating: "Generating…",
			refreshProfile: "Refresh data profile",
			generateProfile: "Generate data profile",
			clinicalDbPatients: "{n} patients in the clinical database",
			profileFieldCount: "profile: {n} fields",
			profileTitle: "Data profile",
			profileTag: "Per-field fill rate / distinct / distribution",
			profileHint: "Analyses expand the raw tree data on demand; this profile helps judge whether a topic has the data it needs",
			multiRecordTag: "Multi-record · expanded on demand during analysis",
			colField: "Field",
			colType: "Type",
			colFillRate: "Fill rate",
			colUniqueCount: "Distinct",
			colDistribution: "Distribution / sample",
			emptyDatasets: "No datasets yet. Use the button above to upload one.",
			colDatasetName: "Dataset name",
			colDatasetCode: "Code",
			colSource: "Source",
			colLatestVersion: "Latest version",
			colHeaderRows: "Header rows",
			colDescription: "Description",
			colUploadTime: "Uploaded",
			actVersions: "Versions",
			actDownload: "Download",
			actRename: "Rename",
			previewTitle: "Data preview",
			previewBaseline: "Basic info / baseline",
			previewBaselineCount: "{n} patients",
			previewFollowup: "Follow-up records",
			previewFollowupCount: "{n} records",
			emptyPreview: "No preview data",
			uploadNewDataset: "Upload new dataset",
			uploadNewVersion: "Upload new version",
			fieldSelectDataset: "Select dataset",
			placeholderSelectDataset: "Select the dataset to update",
			placeholderDatasetName: "e.g. Gastric cancer patient dataset",
			fieldDatasetCode: "Dataset code",
			placeholderDatasetCode: "Optional — leave blank to generate automatically",
			fieldHeaderRowCount: "Header row count",
			fieldVersion: "Version number",
			placeholderVersionDesc: "Version description (optional)",
			fieldDataFile: "Data file",
			dragOrClick: "Drag files here, or",
			clickToUpload: "click to upload",
			tipDatasetFormats: "Supports .xlsx, .xls, .csv",
			uploading: "Uploading…",
			upload: "Upload",
			versionsTitle: "Dataset versions",
			colVersion: "Version",
			colStatus: "Status",
			tagCurrent: "Current",
			colRowCount: "Rows",
			colColumnCount: "Columns",
			colCreateTime: "Created",
			actActivate: "Activate",
			renameTitle: "Rename dataset",
			placeholderDescriptionOptional: "Description (optional)",
			profileDone: "Data profile generated",
			profileDoneDetail: "Fill rate and distribution computed for {n} fields",
			generateFailed: "Generation failed",
			uploadReference: "Upload reference file",
			referenceHint: "Upload any files the study needs to reference",
			emptyReference: "No reference files",
			colFileName: "File name",
			colFileSize: "File size",
			placeholderFileDesc: "File description (optional)",
			fieldFile: "File",
			maxFiles5: " (up to 5)",
			uploadGuidance: "Upload guideline",
			extracting: "Extracting…",
			extractTopics: "Extract research topics",
			guidanceHint: "Upload guideline PDFs, then tap Extract research topics to let AI propose research directions",
			emptyGuidance: "No guidelines yet. Use the button above to upload guideline PDFs.",
			colTitle: "Title",
			colRelevance: "Relevance",
			colTopics: "Topics",
			topicsExtracted: "{n} extracted",
			statusFailed: "Failed",
			statusPending: "Pending",
			placeholderBatchDesc: "Batch description (optional — applied to every file in this upload)",
			maxFiles20: " (multiple, up to 20)",
			tipGuidanceFormats: "Supports .pdf files; a file whose name already exists is skipped",
			resultOk: "Uploaded",
			resultSkipped: "Skipped",
			extractDone: "Extraction complete",
			extractFailed: "Extraction failed",
			searching: "Searching…",
			searchPubmed: "Search PubMed",
			searchCT: "Search ClinicalTrials.gov",
			researchHint: "Search treatment-outcome literature and clinical trials using the project's ICD-10 codes",
			pubmedSearchDone: "PubMed search complete:",
			pubmedSearchFailed: "PubMed search failed:",
			ctSearchDone: "ClinicalTrials search complete:",
			ctSearchFailed: "ClinicalTrials search failed:",
			emptyResearch: "No research literature yet. Use the buttons above to search PubMed or ClinicalTrials.gov.",
			colJournalStatus: "Journal / status",
			colPubDate: "Published",
			actLink: "Link",
			fieldCount: "Count",
			start: "Start",
			startSearch: "Start search",
			typeNumber: "Number",
			typeString: "Text",
			typeDate: "Date",
			typeSingleSelect: "Single select",
			typeMultiSelect: "Multi select",
			avgSelections: "avg. {n} selected",
			numericRange: "{min}–{max} (mean {mean})",
			sourceUpload: "Upload",
			sourceResearch: "Research output",
			sourceDbImportLegacy: "DB import (legacy)",
			sourceDatabase: "Database",
			sourceAiFilter: "AI filter",
			msgNewDatasetUploaded: "Dataset uploaded",
			msgNewVersionUploaded: "New version uploaded",
			msgUploadFailed: "Upload failed",
			msgColumnMismatch: "Columns don't match the previous version. Please keep the data structure consistent.",
			msgPreviewFailed: "Failed to load preview data",
			msgVersionsFailed: "Failed to load version information",
			msgRenameSuccess: "Renamed",
			msgRenameFailed: "Rename failed",
			confirmDeleteDataset: "Delete dataset “{name}”? All of its versions will be deleted too.",
			confirmDeleteTitle: "Confirm deletion",
			msgDatasetDeleted: "Dataset deleted",
			msgDeleteFailed: "Delete failed",
			msgDownloadFailed: "Download failed",
			msgVersionActivated: "Version activated",
			msgActivateFailed: "Activation failed",
			confirmDeleteVersion: "Delete version {version}?",
			msgVersionDeleted: "Version deleted",
			confirmGenerateProfile: "All records for the {n} patients in the clinical database will be scanned to compute a per-field profile (fill rate, distinct count, value distribution), so you can judge which topics already have data. This may take a few minutes.",
			msgProfileStartFailed: "Failed to start generation",
			msgInitializing: "Initialising…",
			msgProcessing: "Processing…",
			msgRefUploaded: "Reference files uploaded",
			confirmDeleteFile: "Delete file “{name}”?",
			uploadProgress: "Uploading ({current}/{total})",
			msgFilesUploaded: "Uploaded {n} files",
			msgFilesSkipped: ", {n} skipped",
			msgNoFileUploaded: "No files were uploaded",
			confirmDeleteNamed: "Delete “{name}”?",
			msgExtractAlreadyRunning: "An extraction is already running…",
			msgExtractStartFailed: "Failed to start extraction",
			extractSummary: "Processed {processed} documents, extracted {topics} topics",
			extractSkipped: ", {n} skipped",
			crawlPubmedTitle: "Search PubMed literature",
			crawlPubmedMessage: "PubMed will be searched for treatment-outcome literature using the project's ICD-10 codes.",
			msgPubmedStarted: "PubMed search started — you can keep working",
			msgSearchAlreadyRunning: "A search is already running…",
			msgSearchStartFailed: "Failed to start search",
			researchSummary: "Retrieved {downloaded}, skipped {skipped}",
			researchFailedCount: ", {n} failed",
			msgSearchFailed: "Search failed",
			crawlCtTitle: "Search ClinicalTrials.gov trials",
			crawlCtMessage: "ClinicalTrials.gov will be searched for related trials using the project's ICD-10 codes.",
			msgCtStarted: "ClinicalTrials search started — you can keep working",
			ctSummary: "Retrieved {downloaded}, skipped {skipped}",
			ctFailedCount: ", {n} failed",
			docTitleWithFile: "{desc} ({file})",
		},
		researchHome: {
			noDisease: "Disease not set",
			noObjective: "Research objective not set",
			activeResearch: "Research in progress",
			viewAll: "View all",
			continueAnalysis: "Continue analysis",
			recommendedTopics: "Recommended topics (data-ready)",
			dataReadyPct: "Data ready {n}%",
			treatmentInsights: "Treatment insights",
			exploring: "Exploring…",
			exploreNow: "Explore now",
			autopilotAlertWithTopic: "Auto-exploration in progress: analysing 「{title}」 — takes about 1–3 hours, you may leave this page",
			autopilotAlert: "Auto-exploration in progress — about 1–3 hours. Completed studies and insights appear automatically; you can leave this page.",
			noInsights: "No treatment insights yet — key findings are distilled automatically once a study completes",
			pickDataReadyTopic: "Pick a data-ready topic",
			openWorkbench: "Open the workbench",
			researchRecords: "Research records",
			colTitle: "Study title",
			colStatus: "Status",
			colCohort: "Cohort",
			colInsights: "Insights",
			colUpdatedAt: "Updated",
			noResearch: "No studies yet — start in one click from a data-ready topic",
			projectSettings: "Project settings",
			diseaseName: "Disease name",
			diseasePlaceholder: "e.g. gastric cancer",
			icd10Codes: "ICD-10 codes",
			icd10Placeholder: "Type a code and press Enter to add",
			researchObjective: "Research objective",
			objectivePlaceholder: "Describe the overall research direction and goals of this project",
			autopilot: "Auto-explore",
			intervalPrefix: "Run every",
			intervalSuffix: "days automatically",
			autopilotOffHint: "When off, you can still start an analysis manually from the topics page",
			autopilotHint: "Each run discovers topics automatically and completes one statistical analysis (about 1–3 hours of inference capacity); it starts at 3 am when due.",
			statDocuments: "Research documents",
			statTopics: "Recommended topics",
			statAnalyses: "Analysis tasks",
			subDataReady: "{n} data ready",
			subActive: "{n} in progress",
			subFindings: "{n} findings",
			autopilotDone: "Auto-exploration finished",
			autopilotConfirmMsg: "Research topics will be discovered automatically and analysed one at a time — if a result is not significant the next direction is tried, until a statistically significant finding is produced or the candidate topics run out. This may run for several hours and consume substantial inference capacity. Start now?",
			startExplore: "Start exploring",
			autopilotAlreadyRunning: "Auto-exploration is already running",
			autopilotStarted: "Auto-exploration started. New studies and insights will appear when it completes.",
			autopilotStartFailed: "Failed to start auto-exploration",
			settingsSaved: "Settings saved",
			settingsSaveFailed: "Failed to save settings",
			status: {
				active: "In progress",
				completed: "Completed",
				failed: "Failed",
				archived: "Archived",
			},
		},
		workbench: {
			title: "Research analysis workbench",
			backToList: "Back",
			archivedTitle: "Explored, no significant finding",
			archivedToggle: "Explored, not significant ({n})",
			refresh: "Refresh",
			newStudy: "New study",
			emptyArchived: "No archived explorations",
			emptySessions: "No research sessions yet",
			createFirst: "Create the first study",
			colTitle: "Title",
			tagAuto: "Auto",
			colStage: "Stage",
			colStatus: "Status",
			colCohort: "Cohort",
			colInsights: "Insights",
			colUpdated: "Updated",
			colActions: "Actions",
			open: "Open",
			startOver: "Start over",
			tabPipeline: "Pipeline",
			viewingConfirmedStage: "Viewing a confirmed stage (read-only). Click the {stage} step to return.",
			interpretDisabledHint: "Available once the analysis stage is confirmed",
			tabInterpret: "Interpretation & exploration",
			createTitle: "New research study",
			labelHypothesis: "Hypothesis",
			hypothesisPlaceholder: "e.g. Off-label vs on-label stents for sICAS — safety and mid-term outcomes",
			labelMode: "Mode",
			modeAuto: "Auto-explore (recommended)",
			modeManual: "Step-by-step confirm",
			modeAutoHint: "Runs end-to-end on its own; on a null result it revises strategy and retries (up to 8 rounds). You watch live and can pause / steer / stop anytime.",
			modeManualHint: "You review and confirm each checkpoint before the pipeline continues.",
			labelCohort: "Cohort",
			cohortFromFilter: "From AI filter",
			cohortPaste: "Paste patient IDs",
			cohortLater: "Decide later",
			labelConversation: "Conversation",
			conversationPlaceholder: "Select a saved AI filter conversation",
			labelPatientIds: "Patient IDs",
			patientIdsPlaceholder: "Comma / space / newline separated patient_no",
			create: "Create",
			cohortBlockedReason: "Bind a cohort first — or pick \"use the whole project\" and click Bind.",
			restartConfirm: "Redo this study from step 1? The research card, cohort, variable mapping, results and any interpretations are cleared. The topic, hypothesis and uploaded guidance are kept, and you can bind a different cohort.",
			deleteConfirm: "Delete \"{name}\"? This cannot be undone.",
			deleteTitle: "Delete session",
			status: {
				active: "Active",
				completed: "Completed",
				failed: "Failed",
				abandoned: "Abandoned",
			},
			msg: {
				openFailed: "Failed to open session",
				noProject: "Project not resolved",
				selectConversation: "Select a conversation",
				pastePatientIds: "Paste at least one patient ID",
				createFailed: "Failed to create session",
				restarted: "Restarted — draft the research card again",
				deleted: "Deleted",
				confirmFailed: "Confirm failed",
				rejectFailed: "Reject failed",
			},
		},
		inbox: {
			title: "Treatment review",
			unreadCount: "{n} unread",
			markAllRead: "Mark all as read",
			refresh: "Refresh",
			emptyDesc: "No treatment reviews yet — the platform generates findings automatically as data accumulates and pushes them here",
			viewTopics: "View topic recommendations",
			loadFailed: "Failed to load treatment reviews",
			markedAllRead: "All marked as read",
		},
		insightCard: {
			sourceAnalysisTask: "Source: analysis task",
			autoDiscovered: "Auto-discovered",
			effectSize: "Effect size",
			type: {
				treatmentEfficacy: "Treatment comparison",
				biomarker: "Biomarker",
				survival: "Survival analysis",
				composite: "Composite analysis",
				descriptive: "Data overview",
				autoSchema: "Smart discovery",
			},
		},
		studyInsight: {
			autoDiscovered: "Auto-discovered",
			pendingTooltip: "The report's primary conclusion carries a clinical-value judgement, pending the doctor's confirmation under Author's supplementary notes in the report",
			pendingTag: "Pending confirmation",
			patternTag: "Practice pattern",
			patternTooltip: "Practice-pattern probe: describes care delivery itself (what was done, who received it, how it shifted). No efficacy comparison; not to be read causally",
			findingCount: "{n} findings",
			status: {
				active: "In progress",
				completed: "Completed",
				failed: "Failed",
				abandoned: "Abandoned",
			},
		},
		pipe: {
			interpret: {
				title: "Interpretation & exploration",
				regenerateReport: "Regenerate report",
				generateReport: "Generate report",
				bundle: "Bundle",
				evidenceHint: "The report cites a verified evidence pack of {n} references.",
				roundLabel: "Round {n}",
				tagNeedsReflatten: "needs re-flatten",
				tagProposed: "proposed",
				tagDone: "done",
				reflattenTitle: "This change needs a new session (re-flatten)",
				proposedChanges: "Proposed changes",
				confirmRerun: "Run this re-cut",
				keyEffects: "Key effect estimates",
				conclusion: "Conclusion",
				caveatsLabel: "Statistical caveats",
				limitationsLabel: "Limitations",
				noInterpretation: "No interpretation yet.",
				generateInterpretation: "Generate interpretation",
				stop: "Stop",
				elapsed: "elapsed",
				stepLabel: "step {n}",
				methodSuggestions: "Method suggestions",
				inputPlaceholder: "Suggest a change: adjust covariates, add a subgroup, change the matching caliper, drop an endpoint… (Ctrl+Enter)",
				inputHint: "The agent ensures statistical validity; you confirm clinical relevance.",
				send: "Send",
				working: "Working…",
				model: {
					logistic: "logistic",
					cox: "Cox",
					linear: "linear",
					geeLogistic: "GEE",
					clusterLogistic: "cluster-robust logistic",
					coxTv: "time-varying Cox",
					aipw: "AIPW doubly robust (RD)",
				},
				diff: {
					groupColumn: "Grouping variable",
					positiveGroup: "Exposed arm",
					referenceGroup: "Reference arm",
					covariates: "Covariates",
					tableOne: "Table 1 variables",
					matching: "Propensity matching",
					iptw: "IPTW",
					models: "Models",
					roc: "ROC",
					longitudinal: "Per-timepoint comparison",
					competingRisks: "Competing risks",
					subgroups: "Subgroups",
					subgroupEndpoint: "Subgroup endpoint",
					analysisUnit: "Analysis unit",
					clusterColumn: "Cluster column",
					seed: "Seed",
				},
				diffVal: {
					removed: "(removed)",
					matchingOff: "off",
					caliper: "caliper {v}",
					psOn: "on {cols}",
					iptwStabilized: "stabilized weights",
					iptwUnstabilized: "unstabilized weights",
					none: "none",
				},
				msg: {
					figuresLoadFailed: "Charts failed to load — your session may have expired. Please refresh the page and sign in again.",
				},
				chipAddText: "Please add {name} ({hook}); reason: {reason}.",
				chipMethodText: "Please also run {name} ({hook}).",
			},
			loop: {
				autoExplore: "Auto-explore",
				iterationCount: "iteration {n}/{total}",
				pause: "Pause",
				resume: "Resume",
				stopKeepBest: "Stop & keep best",
				continueExploring: "Continue exploring",
				baselineEvaluation: "Baseline evaluation",
				running: "running…",
				startingFirst: "Starting the first iteration…",
				methodLadder: "Method ladder",
				guidePlaceholder: "Optional steer for the NEXT strategy round, e.g. 'try a visit-level time axis' (Ctrl+Enter to send)",
				guideHint: "The loop keeps running; your note is applied when the AI plans the next iteration.",
				queuedCount: "{n} queued",
				sendGuide: "Send",
				ladderInUse: "in use: {items}",
				ladderNext: "next: {items}",
				ladderSparseEvents: "events too sparse — change endpoint/population, not method",
				axesChanged: "changed: {names}",
				msg: {
					guideQueued: "Queued for the next strategy round",
					guideFailed: "Failed to send",
				},
				stopConfirmText: "Stop exploring? The best result so far is kept, the report is generated (the exploration history stays in this timeline, not in the report), and you can continue later.",
				stopConfirmTitle: "Stop exploring",
				stop: "Stop",
			},
			results: {
				sectionEndpointRates: "Endpoint event rates",
				sectionEffectEstimates: "Effect estimates (adjusted / IPTW / matched)",
				sectionSurvival: "Survival (log-rank)",
				sectionRoc: "ROC / classification",
				sectionTimepoints: "Per-timepoint comparisons",
				sectionTableOneSingle: "Table 1 — cohort descriptives",
				sectionTableOneBalance: "Table 1 — baseline balance",
				sectionMatching: "Propensity-score matching / IPTW",
				sectionCompetingRisks: "Competing risks (Aalen–Johansen + cause-specific Cox)",
				sectionEvalue: "Unmeasured-confounding sensitivity (E-value)",
				sectionSubgroups: "Subgroup analysis",
				sectionFigures: "Figures",
				col: {
					endpoint: "Endpoint",
					evaluable: "Evaluable",
					events: "Events",
					byGroupRate: "By group (rate)",
					model: "Model",
					estimate: "Estimate",
					estimateShort: "Estimate",
					variants: "Variants",
					assumptions: "Assumptions",
					byGroupSurvival: "By group (n / events / median days)",
					cutoff: "Cutoff",
					sens: "Sens",
					spec: "Spec",
					acc: "Acc",
					timepoint: "Timepoint",
					test: "Test",
					pAdj: "P (adj)",
					variable: "Variable",
					overall: "Overall",
					analysis: "Analysis",
					causeSpecificHr: "Cause-specific HR",
					competingCauseHr: "Competing-cause HR",
					cif: "CIF at horizons",
					effect: "Effect",
					rrApprox: "approx. RR",
					evalue: "E-value",
					evalueCi: "E-value (CI bound)",
					level: "Level",
				},
				delongCi: "DeLong 95% CI",
				holmAdjusted: "(Holm-adjusted)",
				interactionP: "interaction P",
				evalueHint: "Minimum confounder association (RR scale, with both exposure and outcome) needed to fully explain the effect away — larger is more robust.",
				matching: {
					method: "Method",
					matchedPairs: "Matched pairs",
					seed: "Seed",
					treatedControl: "Treated / Control",
					maxSmdBefore: "Max SMD before",
					maxSmdAfter: "Max SMD after / weighted",
					weighting: "Weighting",
					weightAto: "Overlap (ATO)",
					weightIptw: "Stabilized IPTW",
					ess: "ESS (weighted)",
					essRatio: "({pct}%)",
					commonSupport: "Common support",
				},
				status: {
					insufficientEvents: "insufficient events",
					insufficientData: "insufficient data",
					nonNumericEndpoint: "non-numeric endpoint",
					noOutcomeVariance: "no outcome variance",
					columnsAbsent: "columns absent",
					endpointAbsent: "endpoint absent",
					unstable: "unstable fit",
					missingTimeEventColumns: "missing time/event",
					insufficient: "insufficient",
					failed: "failed",
					fitFailed: "fit failed",
				},
				refGroup: "Reference",
				posGroup: "Exposed",
				diag: {
					epvText: "{events} events / {parameters} parameters (threshold {threshold})",
					ph: "PH",
					phHolds: "Proportional-hazards assumption holds (Schoenfeld P≥0.05)",
					phViolated: "Violated by: {vars}",
					normality: "Normality",
					equalVar: "Equal var.",
					separation: "Separation",
					separationText: "Quasi-separation suspected — estimate not interpretable",
				},
				listSep: ", ",
				sepSemi: "; ",
				variantStandardizedRd: "standardized RD",
				variantBayesian: "Bayesian",
				pDirection: "P(direction)",
				numericDesc: "{mean} ± {sd}; median {median} ({q1}–{q3}), n={n}",
				rrApproxText: "{rr} ({conversion})",
			},
			stage: {
				round: "round {n}",
				roundShort: "R{n}",
				confirmPlan: "Confirm",
				submitRevision: "Submit revision",
				redraft: "Regenerate",
				regenerate: "Regenerate",
				latestFeedback: "Round {n} feedback",
				earlierFeedback: "Earlier feedback ({n})",
				working: "Working…",
				elapsed: "elapsed",
				step: "step {n}",
				longHint: "Long drafts are normal — the AI reads the project field dictionary before writing. You can leave this page; the step keeps running.",
				executionLog: "Execution log ({n})",
				revisionFeedback: "Revision feedback",
				revisePlaceholder: "Describe the change in plain language, e.g. 'switch the endpoint to 30-day retreatment' (Ctrl+Enter to submit)",
				reviseHint: "The AI redrafts the plan per your feedback; you re-review before anything runs.",
				nothingProposed: "Nothing proposed yet",
				pickLine: "On \"{question}\": use \"{label}\"",
				regenConfirmMsg: "Discard this draft and regenerate from scratch?",
				status: {
					proposed: "awaiting",
					confirmed: "confirmed",
					rejected: "rejected",
					error: "error",
					pending: "pending",
				},
			},
			decision: {
				title: "Key decisions",
				recommended: "recommended",
				applyHint: "This choice will be applied by the AI in a revision round.",
			},
			effect: {
				colEndpoint: "Endpoint",
				colModel: "Model",
				colEffect: "Effect (95% CI)",
				tooFewEvents: "— (too few events)",
				colEvents: "Events",
			},
			verify: {
				titleFail: "Narrative check failed — resolve these before this study reaches the review inbox",
				titleWarn: "Narrative check: minor issues",
				sevContradiction: "contradiction",
				sevNote: "note",
				reviewTitle: "Manuscript review",
				statRounds: "rounds",
				statIssues: "issues",
				statFixed: "fixed",
				statToAuthor: "to author",
				statDropped: "dropped",
				tagBlocker: "blocker",
				tagAuthor: "author",
				claimTitle: "Claim check",
				primaryUnresolved: "primary conclusion awaits doctor confirmation",
				primary: "primary",
				hint: "Every number is computed by the platform — only the AI-written narrative can drift. Regenerate the interpretation or report to re-check.",
				claimSupported: "supported",
				claimPartiallySupported: "partially supported",
				claimUnsupported: "unsupported",
				claimContradicted: "contradicted",
				claimNeedsConfirmation: "needs confirmation",
				quoted: "“{text}”",
			},
			stepper: {
				study_intake: "Study card",
				cohort_confirm: "Cohort",
				variable_mapping: "Variables",
				flatten_preview: "Flatten",
				encoding_exclusion: "Encoding",
				analysis: "Analysis",
				report_export: "Report",
			},
			body: {
				study: {
					disease: "Disease",
					hypothesis: "Hypothesis",
					design: "Design",
					groupingVariable: "Grouping variable",
					onLabel: "On-label",
					offLabel: "Off-label",
					endpoints: "Endpoints",
					covariates: "Covariates",
				},
				cohort: {
					source: "Source",
					matched: "Matched",
					filterConversation: "Filter conversation",
					querySummary: "Query summary",
					samplePatients: "Sample patients:",
					unboundWarning: "No cohort bound — the whole project will be analyzed.",
					unboundPickWarning: "No cohort bound — confirming now would analyze the WHOLE project. Pick a cohort below.",
					changeCohort: "Change cohort",
					modeConversation: "From AI filter",
					modeManual: "Paste patient IDs",
					modeAll: "Whole project",
					selectConversationPlaceholder: "Select a saved AI filter conversation",
					matchedCountSuffix: " ({n} matched)",
					noConversations: "No saved AI filter conversations — build one under Data Management → Advanced Filter → AI Filter.",
					pastePlaceholder: "Comma / space / newline separated patient_no",
					allNote: "Explicitly analyze every patient in this project.",
					bindCohort: "Bind cohort",
					msg: {
						selectConversation: "Select a conversation",
						pasteAtLeastOne: "Paste at least one patient_no",
						wholeProjectSelected: "Whole project selected",
						cohortBound: "Cohort bound: {n} patients",
						bindFailed: "Bind failed",
					},
				},
				variables: {
					endpointCount: "{n} endpoints",
					groupCount: "{n} groupings",
					visitLevel: "Visit-level analysis",
					studyGroups: "Study groups",
					presenceRule: "has a {field} record → {pos}, otherwise → {neg}",
					cutAt: "cut at {cuts}",
					quantileRule: "split at cohort quantile {cuts} (threshold resolved on the confirmed cohort)",
					endpoints: "Endpoints",
					survival: "Survival analysis",
					positiveValue: "counts as an event when the value is \"{v}\"",
					dataIncluded: "Data included",
					allDataKept: "All models and fields are kept; repeated records are summarised by field type (numeric → mean, dates → earliest, others → merged).",
					noSpecTitle: "No grouping variable or endpoint defined yet",
					noSpecDesc: "Confirming now yields descriptive statistics only. For a between-group comparison, describe the groups and endpoints in the Revision feedback box below, or select Regenerate.",
					allModels: "All models",
					modelCount: "{n} models",
					dayRange: "day {lo}–{hi}",
					atDay: "day {d}",
					atDayTol: "day {d} ({tol}d)",
					sustained: "sustained ≥{d}d",
					binarize: "event when {rule}",
				},
				flatten: {
					patientRows: "patient rows",
					visitRows: "visit rows",
					analysisRows: "analysis rows",
					codebookCols: "codebook cols",
					deriveSummary: "Derivation summary",
					colKey: "Key",
					colValue: "Value",
					previewTitle: "Table preview (first rows)",
					tabPatient: "Patient",
					tabVisit: "Visit",
					tabAnalysis: "Analysis",
				},
				encoding: {
					exclusionRules: "Exclusion rules",
					keep: "keep:",
					variableEncoding: "Variable encoding",
					colVariable: "Variable",
					colPositive: "Positive value",
					missingPolicy: "Missing-data policy",
				},
				analysis: {
					analysisN: "Analysis N",
					groups: "Groups",
					grouping: "Grouping",
					covariates: "Covariates",
					matching: "Matching",
					models: "Models",
					methodCheck: "Method check",
					applicable: "applicable",
					suggested: "upgrades suggested",
					inUse: "In use",
					alsoApplicable: "Also applicable",
					notFeasible: "Not feasible",
					roadmap: "Roadmap",
					roadmapHint: "{trigger} (not yet supported by the platform)",
					results: "Results",
				},
				report: {
					title: "Title",
					design: "Design",
					cohort: "Cohort",
					analysisN: "Analysis N",
					groups: "Groups",
					keyFindings: "Key findings",
					colEndpoint: "Endpoint",
					colModel: "Model",
					colEffect: "Effect (95% CI)",
					downloads: "Downloads",
					rebuildTables: "Rebuild data tables",
					pendingAuthor: "{n} item(s) await the author's confirmation — see the report's author checklist (作者补充事项)",
					completedNote: "Session completed. The reproducible bundle re-runs to a byte-identical results.json.",
					rebuildOk: "Tables rebuilt: {n} analysis rows",
					rebuildFailed: "Rebuild failed",
					downloadFailed: "Download not ready",
					dl: {
						bundle: "Bundle (zip)",
						strobeDocx: "Research report (Word)",
						script: "Analysis script",
						scriptR: "R script",
						results: "results.json",
						analysisCsv: "Analysis table",
						patientCsv: "Patient table",
						visitCsv: "Visit table",
						codebook: "Codebook",
					},
				},
			},
			hooks: {
				loopReconnecting: "Connection lost, reconnecting to the auto-explore run…",
				processFailed: "Processing failed",
				explorationDisconnected: "The connection to the server was lost and this task has stopped. Please refresh the page and try again.",
				advanceDisconnected: "The connection to the server was lost and this step may have stopped. Refresh the page: if it is still running you will be reconnected automatically, otherwise you can run the step again.",
				durationMinSec: "{m} min {s} s",
				durationSec: "{s} s",
			},
		},
		dataset: {
			modeNew: "New dataset",
			modeVersion: "New version",
			selectDataset: "Select dataset",
			selectDatasetPlaceholder: "Select the dataset to update",
			datasetName: "Dataset name",
			datasetCodeOptional: "Dataset code (optional)",
			autoGenerateHint: "Generated automatically if left blank",
			version: "Version",
			versionHint: "Suggested version number; edit it if needed",
			headerRowCount: "Header rows",
			headerRowCountHint: "Number of header rows in the data file (1-10)",
			datasetDescription: "Dataset description",
			datasetFile: "Dataset file",
			selectFile: "Select file",
			acceptHint: "Supported extensions: .xlsx, .xls, .csv",
			uploading: "Uploading…",
			uploadNewDataset: "Upload new dataset",
			uploadNewVersion: "Upload new version",
			manageTitle: "Dataset management",
			datasetCode: "Dataset code",
			latestVersion: "Latest version",
			versionDescription: "Version description",
			uploadTime: "Uploaded",
			versionHistory: "Version history",
			viewVersions: "View versions",
			versionsDialogTitle: "Dataset versions",
			createdAt: "Created",
			description: "Description",
			msgSelectFile: "Please select a file",
			msgSelectDatasetToUpdate: "Please select the dataset to update",
			msgDatasetNotFound: "Could not find details for the selected dataset. Please refresh the list or try again.",
			msgUploadNewSuccess: "New dataset uploaded successfully",
			msgUploadVersionSuccess: "New version {version} of dataset {name} uploaded successfully",
			msgUploadError: "An error occurred while uploading the dataset",
			msgColumnMismatch: "Cannot upload the new version: the column definitions do not match the previous version. Please make sure the data structure is consistent.",
			msgFileInvalid: "Cannot process the file: the file format is invalid or corrupted. Please make sure the file is a valid CSV or Excel file.",
			msgLoadDatasetsFailed: "Failed to load datasets",
			msgLoadVersionsFailed: "Failed to load dataset versions",
		},
		nav: {
			title: "Analytics tools",
			overview: "Analytics overview",
			dataset: "Datasets",
			encoding: "Field encoding",
			selection: "Field selection",
			algorithm: "Algorithm runs",
			report: "Statistical report",
		},
		encoding: {
			saveConfig: "Save configuration",
			exportProcessedData: "Export processed data",
			selectDatasetLabel: "Select the dataset to process",
			selectDatasetPlaceholder: "Select a dataset",
			noDatasetsForProject: "No dataset found for this project. Please upload a dataset first.",
			tabMetadata: "1. Field classification",
			datasetLabel: "Dataset",
			rescanMetadata: "Rescan metadata",
			dataTypeDetails: "Data type details",
			numericStats: "Numeric: min: {min}, max: {max}, mean: {mean}, median: {median}, SD: {std}",
			categoricalStats: "Categorical: categories: {categories} (ordered: {ordered})",
			nullFrequency: "Null frequency",
			uniqueCount: "Unique value count",
			dataQuality: "Data quality",
			colColumnName: "Column name",
			colDataType: "Data type",
			colNullable: "Nullable",
			colUnique: "Unique",
			goToImputation: "Go to missing value imputation",
			tabImputation: "2. Missing value imputation",
			noColumnsForImputation: "No columns available for imputation.",
			imputationTip: "An imputation strategy can be set for any column, even one with no missing values. This helps handle missing values that may appear later.",
			fieldStatistics: "Field statistics",
			colMissingBefore: "Missing rate before imputation",
			colImputationStrategy: "Imputation strategy",
			selectStrategy: "Select a strategy",
			colParameters: "Parameters",
			paramTypeTodo: "Parameter type '{type}' is not yet configurable",
			noParameters: "No parameters",
			colMissingAfter: "Missing rate after imputation",
			helpLabel: "Help",
			imputationHelp: "Numeric data can be imputed with the mean or median; categorical data with the mode. Time series data can use last observation carried forward (LOCF). Consider what is clinically meaningful.",
			backToMetadata: "Back to metadata",
			resetToDefault: "Reset to default",
			applyImputationContinue: "Apply imputation and continue",
			tabEncoding: "3. Encoding strategy",
			outputColumnStatistics: "Encoded output column statistics",
			dataLoading: "Loading data...",
			colEncodingStrategy: "Encoding strategy",
			colOutputPreview: "Output column preview",
			infoLossWarning: "The selected encoding strategy may cause information loss (for example, dropping categories).",
			backToImputation: "Back to imputation",
			applyEncodingSave: "Apply encoding and save",
			dataPreviewTitle: "Data preview (sample)",
			refreshPreview: "Refresh preview",
			auditLogTitle: "Transformation audit log",
			noAuditRecords: "No transformation records yet.",
			dataPreview: "Data preview",
			auditLog: "Audit log",
			paramEnter: "Enter {name}",
			paramBasedOnType: " (based on column type: {type})",
			paramDefault: ", default: {value}",
			paramTupleExample: "For example (0, 1), default: {value}",
			paramCommaList: "Comma-separated list, default: {value}",
			msgNoDatasets: "No dataset found",
			msgFetchDatasetsFailed: "Failed to load the dataset list",
			msgLoadDatasetMetadataFailed: "Failed to load dataset metadata",
			auditLoadMetadata: "Load metadata",
			auditLoadMetadataDetail: "Loaded metadata for {n} columns",
			msgNoColumnMetadata: "No column metadata found",
			msgFetchColumnMetadataFailed: "Failed to load column metadata",
			msgRescanComplete: "Metadata rescan complete",
			msgRescanFailed: "Failed to rescan metadata",
			msgResetImputationSuccess: "Reset to the default imputation strategies",
			msgResetImputationFailed: "Failed to reset to the default imputation strategies",
			msgFetchImputationFailed: "Failed to load imputation strategies",
			msgFetchEncodingFailed: "Failed to load encoding strategies",
			columnCount: "({n} columns)",
			msgEncodingSaved: "Encoding strategies saved",
			auditApplyEncoding: "Apply encoding strategies",
			auditApplyEncodingDetail: "Applied encoding strategies to {n} columns",
			msgConfigSavedContent: "The data encoding configuration has been saved. You can download the processed data or continue with other work.",
			msgConfigSavedTitle: "Configuration saved",
			msgApplyEncodingFailed: "Failed to apply encoding strategies",
			msgNoEncodingSelected: "No encoding strategy selected",
			msgProjectOrDatasetMissing: "No project or dataset selected",
			msgImputationApplied: "Imputation strategies applied",
			auditApplyImputation: "Apply imputation strategies",
			auditApplyImputationDetail: "Applied imputation strategies to {n} columns",
			msgApplyImputationFailed: "Failed to apply imputation strategies",
			msgNoImputationSelected: "No imputation strategy selected. Continuing to the encoding step.",
			msgApplyImputationError: "An error occurred while applying imputation strategies",
			sampleData: "Sample data {n}",
			colSampleData: "Data sample",
			msgFetchPreviewFailed: "Failed to load the data preview",
			msgSaveConfigConfirm: "Save the current data processing configuration?",
			msgConfigSaved: "Configuration saved",
			msgExportConfirm: "Export the processed data?",
			exportDataTitle: "Export data",
			msgExportStarted: "Data export started",
			msgCancelConfirm: "Cancel the current operation and go back? Unsaved changes will be lost.",
			msgCancelTitle: "Confirm cancellation",
		},
		selection: {
			datasetSelection: "Dataset selection",
			chooseDataset: "Choose dataset",
			datasetPlaceholder: "Select the dataset for variable selection",
			datasetCode: "Dataset code",
			datasetName: "Dataset name",
			prepProgress: "Data preparation progress",
			roleAssignment: "Column role assignment",
			autoDetectTarget: "Auto-detect target variable",
			selectAllFeatures: "Select all as features",
			clearSelection: "Clear selection",
			selectAllAsX: "Select all as X variables",
			autoDetectY: "Auto-detect Y variable",
			colName: "Column name",
			colDataType: "Data type",
			colStats: "Statistics",
			uniqueValues: "Unique values",
			missingRate: "Missing rate",
			varType: "Variable type",
			selectType: "Select type",
			roleY: "Y variable (target)",
			roleGrouping: "Grouping variable",
			roleX: "X variable (feature)",
			roleId: "ID variable",
			roleExcluded: "Excluded",
			roleUnassigned: "Unassigned",
			powerAnalysis: "Statistical power analysis",
			runPowerAnalysis: "Run power analysis",
			alphaLevel: "Significance level (α)",
			power: "Statistical power",
			effectSize: "Effect size",
			effectSmall: "Small",
			effectMedium: "Medium",
			effectLarge: "Large",
			detectedAnalysis: "Detected {type} analysis",
			regression: "regression",
			classification: "classification",
			powerAdequate: "Statistical power is adequate",
			powerInadequate: "Statistical power is insufficient",
			currentSampleSize: "Current sample size",
			recommendedSampleSize: "Recommended sample size",
			actualPower: "Actual power",
			smartFeatureSelection: "Smart feature selection",
			runFeatureSelection: "Run feature selection",
			featureSelectionAlertTitle: "Smart feature selection based on statistical power analysis",
			featureSelectionAlertDesc: "Lasso regression identifies the most important features while keeping the sample size large enough to maintain statistical power",
			recommendedFeatureCount: "Recommended feature count",
			maxFeaturesAllowed: "Maximum features allowed",
			lassoAlpha: "Lasso α",
			importanceThreshold: "Importance threshold",
			recommendedFeatureList: "Recommended features",
			applyRecommendedFeatures: "Apply recommended features",
			featureImportanceTitle: "Feature importance scores",
			sortDesc: "Descending",
			sortOriginal: "Original order",
			featureName: "Feature name",
			importanceScore: "Importance score",
			optimizationSuggestions: "Optimisation suggestions",
			saveConfig: "Save configuration",
			nextAlgorithm: "Next: algorithm selection",
			columnDetailTitle: "Column details: {name}",
			displayName: "Display name",
			uniqueValueCount: "Unique value count",
			currentRole: "Current role",
			confirmApply: "Apply",
			msgSelectProject: "Please select a project first",
			msgNoDatasets: "No datasets available",
			msgFetchDatasetsFailed: "Failed to load the dataset list",
			msgCannotBeY: "This column cannot be the Y variable (it contains NaN values or its data type is unsuitable)",
			msgCannotBeGrouping: "This column cannot be the grouping variable (it must be categorical)",
			msgNoColumnsForAutoDetect: "No columns available to auto-detect a Y variable.",
			msgAutoDetectedYMoved: "Y variable auto-detected: {name} (previous Y variable {old} moved to X variables).",
			msgAutoDetectedY: "Y variable auto-detected: {name}.",
			msgAutoDetectYFailed: "Could not auto-detect a suitable Y variable. Please select one manually.",
			msgLoadSelectionFailed: "Failed to load the column selection for dataset {dataset}",
			msgSaveSelectionSuccess: "Column selection saved",
			msgSaveSelectionFailed: "Failed to save the column selection",
			msgCompleteSelectionFirst: "Please complete the column selection first",
			msgPowerAnalysisDone: "Power analysis complete",
			msgPowerAnalysisFailed: "Power analysis failed",
			msgCompletePowerAnalysisFirst: "Please complete the power analysis first",
			msgFeatureSelectionDone: "Smart feature selection complete, {n} features recommended",
			msgFeatureSelectionFailed: "Smart feature selection failed",
			msgApplyFeaturesConfirm: "Apply the {n} recommended features as X variables? This will replace the current X variable selection.",
			msgFeaturesApplied: "Recommended feature selection applied",
			stepDatasetSelected: "Dataset selected",
			stepTargetSet: "Target variable set",
			stepFeaturesSelected: "Feature variables selected",
			stepPowerAnalysisDone: "Power analysis complete",
			stepFeatureSelectionDone: "Smart feature selection complete",
			msgCompleteVarConfig: "Please complete the required variable configuration",
			msgConfigSavedRedirect: "Configuration saved, opening algorithm selection",
			msgPrepareAnalysisFailed: "Failed to prepare the analysis: {msg}",
			msgInitFailed: "Initialisation failed",
			msgProjectCleared: "Project information cleared. Please select a project again.",
		},
		algorithm: {
			datasetSelection: "Dataset selection",
			selectDataset: "Select dataset",
			datasetPlaceholder: "Select the dataset to run algorithms on",
			datasetCode: "Dataset code",
			datasetName: "Dataset name",
			configAndRun: "Algorithm configuration and execution",
			dataConfigOverview: "Data configuration overview",
			backToDataPrep: "Back to data preparation",
			targetVariable: "Target variable",
			analysisType: "Analysis type",
			classification: "Classification",
			regression: "Regression",
			featureCount: "Feature variables",
			totalColumns: "Total columns",
			selectedFeatures: "Selected feature variables",
			moreFeatures: "+{n} more…",
			globalConfig: "Global configuration",
			executing: "Running… ({done}/{total})",
			runComparison: "Run algorithm comparison ({selected}/{total})",
			optimizationMetric: "Optimisation metric",
			metricAccuracy: "Accuracy",
			metricPrecision: "Precision",
			metricRecall: "Recall",
			metricF1: "F1 score",
			metricMae: "Mean absolute error",
			metricMse: "Mean squared error",
			metricRmse: "Root mean squared error",
			metricR2: "R² value",
			cvFolds: "Cross-validation folds",
			autoTune: "Auto-tune parameters",
			algorithmSelectionTitle: "Algorithm selection and parameters",
			emptyAlgorithms: "No algorithms available",
			recommended: "Recommended",
			collapseParams: "Hide parameters",
			expandParams: "Show parameters",
			paramConfig: "Parameter configuration",
			noParamsNeeded: "This algorithm needs no parameters",
			comparisonTitle: "Algorithm comparison results",
			exportComparison: "Export comparison",
			clearResults: "Clear results",
			bestAlgorithmTitle: "Best algorithm: {name}",
			bestAlgorithmDesc: "On the {metric} metric, {name} performs best, with a score of {score}",
			metricsComparison: "Performance metrics comparison",
			colAlgorithm: "Algorithm",
			tagBest: "Best",
			colExecTime: "Runtime (s)",
			comparisonCharts: "Algorithm comparison charts",
			chartsGeneratingTitle: "Comparison charts are being generated",
			chartsGeneratingDesc: "The algorithm comparison charts are still being generated. Please refresh shortly.",
			chartPerformanceComparison: "Overall performance comparison",
			chartPerformanceComparisonAlt: "Overall algorithm performance comparison chart",
			chartMetricsHeatmap: "Metrics heatmap",
			chartCvBoxplot: "Cross-validation score distribution",
			chartCvBoxplotAlt: "Cross-validation score distribution chart",
			chartRocComparison: "ROC curve comparison",
			chartRocComparisonAlt: "ROC curve comparison chart",
			chartPrComparison: "PR curve comparison",
			chartPrComparisonAlt: "PR curve comparison chart",
			detailedAnalysis: "{name} detailed analysis",
			chartFeatureImportance: "Feature importance",
			chartFeatureImportanceAlt: "{name} feature importance chart",
			featureImportanceUnavailable: "Feature importance chart unavailable",
			chartConfusionMatrix: "Confusion matrix",
			chartConfusionMatrixAlt: "{name} confusion matrix",
			confusionMatrixUnavailable: "Confusion matrix chart unavailable",
			chartMetrics: "Performance metrics",
			chartMetricsAlt: "{name} performance metrics chart",
			chartRocCurve: "ROC curve",
			chartRocCurveAlt: "{name} ROC curve",
			executionLog: "Execution log",
			noDatasetTitle: "Select a dataset",
			noDatasetDesc: "Choose a dataset that has completed data preparation before running algorithm analysis",
			msgLoadConfigFailed: "Failed to load the data configuration",
			msgLoadAnalysisFailed: "Failed to load the existing analysis",
			msgLoadAlgorithmsFailed: "Failed to load available algorithms",
			msgSelectAtLeastOne: "Select at least one algorithm",
			msgExecuteSuccess: "Ran {n} algorithms successfully",
			msgComparisonFailed: "Algorithm execution failed: {msg}",
			msgCompleteConfig: "Complete the data configuration and select an algorithm",
			msgScheduleCreated: "Scheduled algorithm run created",
			msgExecuteFailed: "Failed to run the algorithm",
			msgChartImageFailed: "Failed to load the chart image",
			msgComparisonExported: "Comparison results exported",
			msgNoProjectInfo: "Cannot load datasets without project information. Please make sure a project is selected.",
			msgNoDatasets: "No datasets found, or the data format is invalid",
			msgLoadDatasetsFailed: "Failed to load the dataset list: {msg}",
			msgInitFailed: "Initialisation failed",
		},
		report: {
			contextTitle: "Study context",
			analysisDone: "Algorithm analysis complete",
			analysisPending: "Awaiting algorithm analysis",
			projectCode: "Project code:",
			dataset: "Dataset:",
			sampleSize: "Sample size:",
			casesUnit: "cases",
			bestAlgorithm: "Best algorithm:",
			targetVariable: "Target variable:",
			modelPerformance: "Model performance:",
			configTitle: "Report configuration",
			loadConfig: "Load configuration",
			refreshList: "Refresh list",
			saveConfig: "Save configuration",
			generateStrobe: "Generate STROBE report",
			selectDatasetFirst: "Please select a dataset first",
			selectDatasetHint: "Select a dataset that has completed data processing and algorithm analysis to generate a report",
			datasetPlaceholder: "Select a dataset",
			sectionBasic: "Basic information",
			studyTitle: "Study title",
			studyTitlePlaceholder: "e.g. Effect of the XXX treatment regimen on patient prognosis",
			researchObjective: "Research objective",
			researchObjectivePlaceholder: "Describe your research objective in detail, including:\n1. The research question or hypothesis\n2. The relationship you expect to verify\n3. The clinical significance or practical value\n\nExample: This study evaluates the effect of different chemotherapy regimens on overall survival in patients with advanced gastric cancer, and analyses the predictive value of baseline characteristics for treatment response, so as to provide evidence for clinical treatment decisions.",
			studyDesign: "Study design",
			studyDesignPlaceholder: "Select a study design",
			design: {
				retrospectiveCohort: "Retrospective cohort study",
				prospectiveCohort: "Prospective cohort study",
				caseControl: "Case-control study",
				crossSectional: "Cross-sectional study",
				cohort: "Cohort study",
			},
			sectionReferences: "Reference documents",
			documentManagement: "Document management",
			dropFilesHere: "Drop files here or ",
			clickToUpload: "click to upload",
			uploadTip: "Supports documents (.pdf, .doc, .docx, .txt, .md), data files (.xlsx, .xls, .csv), images (.jpg, .png, .gif, .svg), archives (.zip, .rar) and similar formats",
			descriptionPlaceholder: "Add a document description (optional)",
			uploadFiles: "Upload files",
			uploadedFiles: "Uploaded reference documents ({n})",
			refresh: "Refresh",
			col: {
				filename: "File name",
				size: "Size",
				uploadTime: "Uploaded",
				description: "Description",
				reportName: "Report name",
				templateType: "Template",
				status: "Status",
				createdAt: "Created",
			},
			noDescription: "No description",
			download: "Download",
			noReferenceFiles: "No reference documents yet. You can upload clinical guidelines, research literature and similar documents.",
			studyBackground: "Study background",
			studyBackgroundPlaceholder: "Briefly describe the study background and the clinical question (optional)",
			studyPeriod: "Study period",
			rangeSeparator: "to",
			startTime: "Start",
			endTime: "End",
			monthFormat: "MMM YYYY",
			sectionReportSettings: "Report settings",
			reportTemplate: "Report template",
			tplCompleteTitle: "Complete STROBE report",
			tplCompleteDesc: "Covers all 22 items of the STROBE checklist",
			tplEssentialTitle: "Core STROBE report",
			tplEssentialDesc: "A shortened version covering the key items",
			tplClinicalTitle: "Clinical summary report",
			tplClinicalDesc: "A concise report aimed at clinical use",
			outputFormat: "Output format",
			fmtHtml: "HTML web page",
			fmtPdf: "PDF document",
			fmtWord: "Word document",
			language: "Language",
			langZh: "Chinese",
			langEn: "English",
			langBoth: "Chinese and English",
			advancedOptions: "Advanced options",
			collapse: "Collapse",
			expand: "Expand",
			includeSections: "Sections to include",
			sec: {
				titleAbstract: "Title and abstract",
				introduction: "Introduction",
				methods: "Methods",
				results: "Results",
				discussion: "Discussion",
				conclusion: "Conclusion",
				limitations: "Limitations",
				funding: "Funding",
			},
			specialRequirements: "Special requirements",
			specialRequirementsPlaceholder: "Other special requirements or notes (optional)",
			historyTitle: "Report history",
			previewTitle: "Report preview",
			generatingReport: "Generating the report, please wait...",
			noReportContent: "No report content",
			downloadReport: "Download report",
			rule: {
				studyTitleRequired: "Please enter a study title",
				studyTitleMin: "The title must be at least 5 characters",
				researchObjectiveRequired: "Please enter a research objective",
				researchObjectiveOptional: "The research objective is optional",
			},
			msg: {
				fetchProjectFailed: "Failed to load project information",
				selectProjectFirst: "Please select a project first",
				fetchDatasetsFailed: "Failed to load the dataset list",
				defaultStudyTitle: "{name} data analysis report",
				loadDatasetFailed: "Failed to load dataset information",
				completeRequired: "Please complete the required fields",
				reportGenerating: "The report is being generated, please wait...",
				reportGenerated: "Report generated successfully",
				generateFailed: "Failed to generate the report: {msg}",
				configSaved: "Report configuration saved",
				saveConfigFailed: "Failed to save the configuration: {msg}",
				configsRefreshing: "The configuration list is refreshing, please wait",
				configLoaded: "Configuration loaded: {name}",
				loadConfigFailed: "Failed to load the configuration: {msg}",
				configsRefreshed: "Configuration list refreshed",
				refreshConfigsFailed: "Failed to refresh the configuration list",
				reportDetailUnavailable: "Report details are unavailable",
				loadReportFailed: "Failed to load the report",
				noReportId: "Could not obtain the report ID",
				downloadStarted: "Report download started",
				downloadReportFailed: "Failed to download the report",
				reportsRefreshed: "Report list refreshed",
				loadReferenceFilesFailed: "Failed to load reference documents",
				fileTooLarge: "The file must not exceed 50MB",
				selectFilesToUpload: "Please select the files to upload",
				projectInfoIncomplete: "Project information is incomplete",
				uploadSuccess: "Files uploaded successfully",
				uploadFailed: "File upload failed: {msg}",
				unknownError: "Unknown error",
				fileDownloaded: "File downloaded",
				fileDownloadFailed: "File download failed",
				confirmDeleteFile: "Delete the file \"{name}\"? This action cannot be undone.",
				confirmDeleteTitle: "Confirm deletion",
				fileDeleted: "File deleted",
				fileDeleteFailed: "Failed to delete the file",
				iframeLoadFailed: "Failed to load the report content. Please check that the file URL is correct.",
				fetchProjectFailedPartial: "Failed to load project information; some features may be limited",
				initFailed: "Initialisation failed: {msg}",
				defaultConfigName: "Configuration {time}",
			},
			status: {
				generating: "Generating",
				completed: "Completed",
				failed: "Failed",
				pending: "Pending",
			},
		},
	},
	clinic: {
		operationOverview: "Operations overview",
		appointments: "Appointment add-ons",
		checkins: "Check-ins",
		chatHistory: "Chat history",
		users: "Outpatient users",
		refresh: "Refresh",
		today: "Today",
		last7d: "Last 7d",
		last30d: "Last 30d",
		last90d: "Last 90d",
		custom: "Custom",
		dateSep: "to",
		startDate: "Start",
		endDate: "End",
		kpiTotalUsers: "Total users",
		kpiNewUsers: "New users (period)",
		kpiActiveUsers: "Active users",
		kpiDeactivated: "Deactivated accounts",
		kpiSnapshot: "Snapshot",
		kpiMessages: "Messages (period)",
		kpiConversations: "Conversations (period)",
		kpiUploads: "Uploads (period)",
		kpiFollowupMessages: "Follow-up messages (period)",
		recentRegistrations: "Recent registrations",
		// Outpatient users list
		searchPlaceholder: "Search nickname / phone / openid",
		searchBtn: "Search",
		showDeleted: "Show deleted accounts",
		totalCount: "{n} total",
		emptyUsers: "No users",
		colUser: "User",
		colContact: "Contact",
		colLoginType: "Login",
		colLastLogin: "Last login",
		colStatus: "Status",
		colRemark: "Remark",
		colActions: "Actions",
		statusDeleted: "Deleted",
		statusActive: "Active",
		statusDisabled: "Disabled",
		loginWechat: "WeChat",
		loginPassword: "Password",
		loginBoth: "Both",
		internalFlag: "Early access",
		disable: "Disable",
		restore: "Restore",
		disableTitle: "Disable account",
		restoreTitle: "Restore account",
		disableConfirm: "About to {action} user {name}.",
		disableNote: "Once disabled, the user will see \"Your account has no access\" and cannot continue; existing data is kept.",
		reasonLabel: "Reason (optional, shown to the user)",
		confirm: "Confirm",
		cancel: "Cancel",
		save: "Save",
		opSuccess: "Done",
		opFailed: "Operation failed",
		loadFailed: "Failed to load",
		internalOn: "Early access enabled",
		internalOff: "Early access disabled",
		viewDetail: "Detail",
		// User detail page
		userDetail: "User detail",
		backToList: "Back to list",
		profile: "Profile",
		loginCount: "Login count",
		createdAt: "Registered",
		lastLoginIp: "Login IP",
		patientTimelines: "Patient timelines",
		noPatients: "No patient records",
		correctionHint: "Timelines are system-generated and doctor-correctable; the user's original chats and profile are read-only.",
		tabConversations: "Conversations",
		tabAppointments: "Add-on requests",
		tabCheckins: "Check-ins",
		tabAssessments: "Assessments",
		convTitle: "Conversation",
		convTheme: "Topic",
		convPending: "Pending",
		convMessages: "Messages",
		convLastActive: "Last active",
		patient: "Patient",
		// Patient timeline component
		patientInfo: "Patient info",
		patientName: "Name",
		patientGender: "Gender",
		patientDob: "Date of birth",
		hospitalCards: "Hospital cards",
		baseline: "Baseline",
		followUps: "Timeline events",
		viewSource: "View source",
		assessmentSource: "Source: assessment",
		timelineMissing: "No patient timeline found",
		correctedBadge: "Corrected by doctor",
		correctedAt: "Corrected at",
		editEvent: "Edit",
		deleteEvent: "Delete",
		editEventTitle: "Correct timeline event",
		eventDate: "Date",
		eventType: "Event type",
		removeField: "Remove field",
		undoRemove: "Undo",
		complexFields: "Complex fields",
		complexFieldsNote: "Structured field — edit as JSON; validated before saving.",
		invalidJson: "Invalid JSON in {key}; please fix it before saving",
		addField: "Add field",
		fieldKey: "Field key",
		fieldValue: "Value",
		add: "Add",
		reservedFieldKey: "Reserved field name",
		duplicateFieldKey: "Field already exists",
		noChanges: "No changes detected",
		correctionSaved: "Correction saved",
		correctionFailed: "Operation failed, please retry",
		deleteEventTitle: "Delete confirmation",
		deleteEventConfirm: "Delete this timeline event ({type} {date})? This cannot be undone.",
		eventDeleted: "Deleted",
	},
	discern: {
		title: "AI recognition",
		uploader: "Uploaded by:",
		userType: "User type:",
		identifyStatus: "OCR status:",
		confirmStatus: "Review status:",
		input: "Type here",
		select: "Select…",
		userDoctor: "Doctor",
		userPatient: "Patient",
		userSys: "Admin",
		statusUnfinished: "Pending",
		statusFinished: "Done",
		statusPending: "Pending review",
		statusConfirmed: "Reviewed",
		searchBtn: "Search",
		resetBtn: "Reset",
		qrCode: "QR code",
		batchUpload: "Batch upload",
		colIndex: "No.",
		colUploader: "Uploaded by",
		colUserType: "User type",
		colProject: "Project",
		colFileCount: "Files",
		colUploadTime: "Uploaded",
		colIdentifyStatus: "OCR",
		colIdentifyTime: "OCR time",
		colConfirmStatus: "Review",
		colConfirmUser: "Reviewer",
		colConfirmTime: "Reviewed",
		colOperation: "Actions",
		actView: "View",
		actConfirm: "Review",
		viewTitle: "AI recognition detail",
		batchUploadTitle: "Batch upload",
		dropFiles: "Drop files here, or",
		clickUpload: "click to upload",
		fileTip: "JPG/PNG only, max 10MB per file",
		startUpload: "Upload",
	},
	governance: {
		title: "Approval inbox",
		myTitle: "My requests",
		refresh: "Refresh",
		colId: "Request ID",
		colType: "Type",
		colRequester: "Requester",
		colCreatedAt: "Submitted",
		colStatus: "Status",
		colOperation: "Actions",
		actView: "View",
		actApprove: "Approve",
		actReject: "Reject",
		statusPending: "Pending",
		statusApproved: "Approved",
		statusRejected: "Rejected",
		statusCancelled: "Cancelled",
		drawerTitle: "Request detail",
		approve: "Approve",
		reject: "Reject",
		comment: "Comment",
		commentPh: "Enter your decision rationale",
		noPendingStep: "No pending approval step",
		emptyCommentConfirm: "A rationale is recommended when rejecting. Submit with an empty comment?",
		confirmTitle: "Confirm",
		toastApproved: "Approved",
		toastRejected: "Rejected",
		quickConfirmBody: "{action} request #{id}?",
		quickConfirmTitle: "Confirm action",
	},

	consent: {
		admin: {
			tabTemplates: "Templates",
			tabSignatures: "Doctor signatures",
			noProject: "No project in the URL — open this page from Project management.",
			noPermission: "You do not have consent template management rights; contact an administrator.",
			templateHint: "One published version per family; a published template cannot be edited — create a new version instead.",
			templateEmpty: "This project has no consent templates yet",
			newTemplate: "New template",
			colFamily: "Family",
			colName: "Name",
			colVersion: "Version",
			colStatus: "Status",
			colSource: "Source",
			colPages: "Pages",
			colUpdated: "Updated",
			colActions: "Actions",
			status: {
				DRAFT: "Draft",
				ACTIVE: "Published",
				RETIRED: "Retired",
			},
			actZones: "Mark zones",
			actPreview: "Preview",
			actEdit: "Edit",
			actPublish: "Publish",
			actRetire: "Retire",
			actNewVersion: "New version",
			actDelete: "Delete",
			familyHint: "Family code of this consent form, e.g. F2F (face to face) or PHONE",
			versionHint: "e.g. V3.0a",
			sourcePdf: "PDF upload",
			sourceText: "Plain text",
			file: "Template file",
			chooseFile: "Choose PDF",
			fileHint: "Unencrypted PDF files only",
			textBody: "Body",
			textHint: "A PDF is generated from this text, with a standard signature page appended",
			remark: "Remark",
			effectiveDate: "Effective date",
			effectiveDatePlaceholder: "Pick a date",
			editMeta: "Edit template details",
			createIncomplete: "Family, name and version are all required",
			needPdf: "Choose the PDF template file",
			needText: "Enter the template body",
			createDone: "Template created as a draft",
			saveDone: "Saved",
			publishConfirm: "Publish \"{name}\"? The published version of the same family will be retired automatically.",
			publishDone: "Template published",
			retireConfirm: "Retire \"{name}\"? It will no longer be offered for signing.",
			retireDone: "Template retired",
			newVersionBody: "Copy {version} into a new draft — enter the new version label",
			versionRequired: "A version label is required",
			newVersionDone: "New draft version created",
			deleteConfirm: "Delete \"{name}\" {version}? This cannot be undone.",
			deleteDone: "Template deleted",
			zoneTitle: "Mark signature zones",
			zoneList: "Zones",
			zoneEmpty: "No zones marked yet",
			zoneNoSelection: "Drag on the page to create a zone, or click an existing one to edit it",
			zoneReadonly: "Read-only",
			zoneReadonlyHint: "Published and retired templates cannot be re-marked — create a new version",
			zoneDrawHint: "Drag empty space to create; drag a box to move; drag a corner to resize; Delete removes the selection",
			zoneDirty: "Unsaved changes",
			zoneSave: "Save zones",
			zoneSaved: "Zones saved",
			zoneDiscardTitle: "Discard unsaved changes?",
			zoneDiscardBody: "The zones have not been saved; closing now loses the changes.",
			zoneKey: "Key",
			zoneKeyHint: "Lower-case letters, digits and underscores, 1-32 characters; matches the signature image at signing time",
			zoneKeyInvalid: "Lower-case letters, digits and underscores only, 1-32 characters",
			zoneKeyInvalidAt: "Zone key \"{key}\" is invalid: lower-case letters, digits and underscores only, 1-32 characters",
			zoneKeyDuplicate: "Zone key \"{key}\" is used twice",
			zoneType: "Type",
			zoneRole: "Role",
			zoneLabel: "Label",
			zoneSource: "Auto-fill",
			zonePage: "Page",
			zoneFormat: "Format",
			zoneFormatHint: "e.g. dd MMM yyyy, or yyyy年MM月dd日 for a Chinese form — required for date and time zones",
			zoneRect: "Position and size (page fractions 0-1)",
			zoneRectHint: "x/y is the top-left corner, w/h the size — all as a fraction of the page",
			zoneRequired: "Required",
			zoneMask: "Mask",
			zoneMaskHint: "Paint the area white before stamping — covers preprinted text",
			zoneDelete: "Delete this zone",
			prevPage: "Previous",
			nextPage: "Next",
			type: {
				SIGNATURE: "Signature",
				DATE: "Date",
				DATETIME: "Date and time",
				DATETIME_RANGE: "Time range",
				TEXT: "Text",
				CHECKBOX: "Checkbox",
			},
			source: {
				none: "None",
				patient_no: "Participant screening number",
				patient_name: "Participant name",
				doctor_name: "Investigator name",
				signed_date: "Signing date",
			},
			signatureHint: "Signature images for project members; the Investigator zone always uses the signer's own signature.",
			memberEmpty: "This project has no members yet",
			colNickname: "Name",
			colUsername: "Account",
			colSignature: "Signature",
			noSignature: "Not set",
			actUpload: "Upload",
			actDraw: "Draw",
			actDeleteSignature: "Delete",
			chooseImage: "Choose image",
			uploadHint: "A PNG with a transparent background works best; tick \"Drop white background\" for a white-background scan.",
			needImage: "Choose a signature image",
			needDrawing: "Draw the signature first",
			signatureSaved: "Signature saved",
			signatureDeleted: "Signature deleted",
			deleteSignatureConfirm: "Delete the signature of {name}?",
		},
		panel: {
			title: "Consent Form",
			sign: "Sign Consent Form",
			empty: "No signed consent yet",
			colTemplate: "Template",
			colVersion: "Version",
			colSignedDate: "Signed On",
			colDoctor: "Investigator",
			colStatus: "Status",
			view: "View",
			download: "Download",
			voidAction: "Void",
			voidPromptTitle: "Void Signed Consent",
			voidPromptBody: "A voided record no longer counts as valid consent; the file itself is kept. Please give a reason ({template}).",
			voidReasonPlaceholder: "Reason for voiding, up to 200 characters",
			voidReasonRequired: "A reason is required",
			voidReasonTooLong: "The reason cannot exceed 200 characters",
			voidDone: "Record voided",
		},
		status: {
			SIGNED: "Signed",
			VOID: "Voided",
		},
		role: {
			PATIENT: "Participant",
			DOCTOR: "Investigator",
			GUARDIAN: "Guardian",
			WITNESS: "Impartial Witness",
			OTHER: "Other Details",
		},
		dialog: {
			title: "Sign Consent Form",
			stepTemplate: "Select Template",
			stepRead: "Read in Full",
			stepSign: "Sign",
			prev: "Back",
			next: "Next",
			submit: "Confirm & Sign",
			selectTemplateHint: "Choose the consent form version to sign.",
			readHint: "Read the full document with the participant; scroll to the last page to continue.",
			readEnd: "End of document",
			pageOf: "Page {n} of {total}",
			signedDate: "Signed Date",
			signedDateHint: "Defaults to today; editable.",
			followsSignedDate: "Follows the signed date above",
			rangeStart: "Start time",
			rangeEnd: "End time",
			noZones: "This template has no marked signature zones yet — please contact the project administrator.",
			optionalSection: "If applicable",
			expand: "Expand",
			collapse: "Collapse",
			signature: "Signature",
			submitSuccess: "Consent signed",
			templateLoadFailed: "Failed to load the template",
			popupBlocked: "Signed. Your browser blocked the new window — use View in the list below to open it.",
		},
		doctor: {
			stored: "Saved signature",
			redraw: "Sign again",
			useStored: "Use saved signature",
			saveAsMine: "Save as my signature",
			noStored: "You have no saved signature yet — tick the box to save this one.",
		},
		pad: {
			tabDraw: "Draw",
			tabUpload: "Upload image",
			tabType: "Type name",
			drawHint: "Sign inside the box below",
			upload: "Choose image",
			whiteToAlpha: "Drop white background",
			namePlaceholder: "Enter name",
			undo: "Undo",
			clear: "Clear",
			required: "Required",
			optional: "Optional",
			imageFailed: "Could not read the image",
			notImage: "Please choose an image file",
		},
		validate: {
			signatureRequired: "Please complete the \u201c{label}\u201d signature",
			valueRequired: "Please fill in \u201c{label}\u201d",
			rangeInvalid: "The end time of “{label}” cannot be earlier than its start time",
		},
	},
	basicInfo: {
		doctor: "Attending doctor",
		maskedDoctor: "*** Doctor",
		hospital: "Institution",
		maskedHospital: "**** Hospital",
		input: "Type here",
		enrollDate: "Enrollment date",
		select: "Select…",
		status: "Status",
		diagnosis: "Diagnosis",
		diagnosisPh: "Enter diagnosis",
	},
	patientInfo: {
		patientNo: "Patient ID",
		randomNo: "Random ID",
		name: "Name",
		gender: "Gender",
		age: "Age",
		ageUnit: "yrs",
		dob: "Date of birth",
		phone: "Phone",
		idNumber: "ID number",
		project: "Project",
		enrollDate: "Enrolled",
		status: "Status",
		doctor: "Attending doctor",
		hospital: "Institution",
	},
	followupRecord: {
		recordTitle: "Follow-up records",
		newRecord: "New visit",
		emptyHint: "No follow-up records yet",
		actView: "View",
		actEdit: "Edit",
		actDelete: "Delete",
		visitName: "Visit",
		dueDate: "Due",
		actualDate: "Completed",
		statusPending: "Pending",
		statusOverdue: "Overdue",
		statusDone: "Done",
		confirmCancel: "Cancel this visit?",
		menuSelect: "Pick template",
		menuDelete: "Delete template",
		menuAdd: "Add ad-hoc visit",
		dialogSelectTitle: "Pick a follow-up plan template",
		dialogAddTitle: "Add ad-hoc visit",
		fieldProjectName: "Project:",
		fieldTemplate: "Template:",
		fieldStart: "Start date:",
		select: "Select…",
		datePh: "Pick a date",
		ruleTemplate: "Pick a template",
		ruleStart: "Pick a start date",
		generatePlan: "Generate plan",
		confirmDelete: "This cannot be undone. Delete?",
		confirmDeleteOne: "Delete this follow-up record? This cannot be undone.",
		dialogTipTitle: "Confirm",
		deleteSuccess: "Deleted",
		dialogEditTitle: "Edit follow-up record",
		fieldVisitName: "Visit name",
		fieldVisitType: "Visit type",
		typePlan: "Planned visit",
		typeNoPlan: "Ad-hoc visit",
		fieldPlan: "Follow-up plan",
		fieldConfig: "Plan node",
		namePh: "Enter visit name",
		rulePlan: "Pick a follow-up plan",
		ruleConfig: "Pick a plan node",
		editSuccess: "Saved",
	},
	upgradation: {
		dialogTitle: "Upgrade plan",
		selectLevel: "Select plan",
		level: "Plan",
		duration: "Duration",
		monthly: "{n} month(s)",
		yearly: "{n} year(s)",
		price: "Price",
		discount: "Verified users save 50%",
		payNow: "Pay now",
		paySuccess: "Payment successful",
		payFailed: "Payment failed",
		qrTip: "Scan with WeChat to pay",
	},
	fileUpload: {
		click: "Click to upload",
		drop: "or drop files here",
		tip: "JPG / PNG / PDF supported",
		preview: "Preview",
		download: "Download",
		remove: "Remove",
		removeConfirm: "Remove this file?",
		uploading: "Uploading…",
		uploaded: "Uploaded",
		uploadFailed: "Upload failed",
		uploadFailedWithReason: "Upload rejected: {reason}",
		duplicateRejected: "Duplicate file rejected — this file has already been uploaded for this patient.",
		exceed: "Too many files",
		view: "View",
		upload: "Upload",
		dialogUploadTitle: "Upload Files",
		dialogViewTitle: "View Files",
		cancelUpload: "Cancel Upload",
		selectFile: "Choose File",
		dragHint: "Drag files here, or",
		clickToSelect: "click to select",
		aiOcr: "AI Recognition",
		submitted: "Submitted",
		selectAll: "Select All",
		selected: "{n} selected",
		emptyData: "No data",
	},
	patientList: {
		patientNoOrName: "Patient ID / name:",
		enrollDate: "Enrolled:",
		startDate: "Start",
		endDate: "End",
		center: "Centre:",
		searchPlaceholder: "Type here",
		searchKeyword: "Type to search",
		searchBtn: "Search",
		resetBtn: "Reset",
		colIndex: "No.",
		colCompleteness: "Completeness",
		colOperation: "Actions",
		dragReorderTip: "Drag to reorder columns (this browser only)",
		actDetail: "Patient",
		actFollowup: "Follow-up",
		actImaging: "Imaging",
		actImagingWorkspace: "Imaging workspace",
		actTimeSeries: "Time series",
		actDelete: "Delete",
		deleteSuccess: "Deleted",
		deleteConfirm: "Delete this patient record? This cannot be undone.",
		deleteTitle: "Confirm",
		add: "Add patient",
		export: "Export",
		batchEnroll: "Batch enroll",
		import: "Import",
		advancedFilter: "Advanced filter",
		colPatientNo: "Patient ID",
		colName: "Name",
		colGender: "Gender",
		colBirth: "Date of birth",
		colAge: "Age",
		colEnrollDate: "Enrolled",
		colCenter: "Centre",
		genderMale: "Male",
		genderFemale: "Female",
		genderUnknown: "Unknown",
		ageYears: "yrs",
		viewSource: "Source",
	},
	patientDetail: {
		add: "Add patient",
		edit: "Edit patient",
		fileView: "Patient file view",
		basicInfo: "Basic info",
		save: "Save",
		saveDraft: "Save draft",
		discard: "Discard changes",
		nextForm: "Next",
		prevForm: "Back",
		visitRecords: "Visits",
		followups: "Follow-ups",
		documents: "Imaging / files",
		newVisit: "New visit",
		fieldRequired: "Required",
	},
	retrieval: {
		title: "Data retrieval",
		exportTitle: "Data retrieval — export",
		searchPlaceholder: "Type to search",
		newQuery: "New query",
		runQuery: "Run query",
		exportResult: "Export results",
		conditions: "Filters",
		results: "Results",
		colIndex: "No.",
		colName: "Query name",
		colCreatedAt: "Created",
		colOperation: "Actions",
		actView: "View",
		actEdit: "Edit",
		actDelete: "Delete",
		actExport: "Export",
		actRun: "Run",
		deleteGroup: "Delete group",
		selectValues: "Select value(s)",
		enterValue: "Enter a value",
		fieldTreeFailed: "Couldn't load the field list",
		selectAnalysisField: "Pick a field to analyse first",
		condition: {
			is: "Equals",
			ne: "Not equals",
			gt: "Greater than",
			gte: "Greater than or equal",
			lt: "Less than",
			lte: "Less than or equal",
			regex: "Fuzzy match",
			exists: "Has value",
			in: "In list",
			nin: "Not in list",
			all: "Contains all",
			yes: "Yes",
			no: "No",
			and: "Match all conditions",
			or: "Match any condition",
			nor: "Match none of the conditions",
		},
		stats: {
			title: "Result statistics",
			chart: "Chart",
			chartTypePlaceholder: "Select chart type",
			startDate: "Start date",
			endDate: "End date",
			startDatePlaceholder: "Select start date",
			endDatePlaceholder: "Select end date",
			barChart: "Bar chart",
			pieChart: "Pie chart",
			sampleSize: "Sample size",
			max: "Max",
			min: "Min",
			median: "Median",
			avg: "Mean",
		},
		exportPage: {
			searchConditions: "Search conditions",
			saveAsTemplate: "Save as template",
			resultList: "Search results",
			colPatientNo: "Patient ID",
			colPatientName: "Patient name",
			colEnrollmentDate: "Enrollment date",
			colAge: "Age",
			colBirthday: "Date of birth",
			colDoctor: "Attending doctor",
			colEnrollmentStatus: "Enrollment status",
			colLastUpdated: "Last updated",
			colUpdatedBy: "Updated by",
			colDataManage: "Data",
			patientDetail: "Patient details",
			followUpDetail: "Follow-up details",
			templateNamePlaceholder: "Enter a template name",
			templateNameRequired: "Please enter a template name",
			templateSaved: "Template saved",
			joinSubProject: "Enrol into sub-project",
			existingSubProjects: "Existing sub-projects",
			subProjectName: "Sub-project name",
			projectStartDate: "Project start date",
			projectEndDate: "Project end date",
			enrolledCount: "Enrolled",
			actEnrol: "Enrol",
			addSubProject: "Add sub-project",
			basicInfo: "Basic info",
			rootProjectName: "Root project name",
			projectLeader: "Project lead",
			leaderUnit: "Lead's unit",
			projectGoal: "Project goal",
			selectSubProject: "Please select a sub-project",
			aiFilterTag: "AI filter",
		},
		exportDialog: {
			title: "Data export",
			exportAll: "Export all forms and models",
			exportPartial: "Export selected forms and models",
			selectForms: "Select the forms and models to export",
			approvalConfirm: "Exports from this project require approval before download. Submit an export request?",
			approvalTitle: "Approval required",
			submitRequest: "Submit request",
			requestId: "Request ID",
			status: "Status",
			requestPending: "Your export request is awaiting reviewer approval. Track its progress in My Requests.",
			requestSubmitted: "Export request submitted",
			goToMyRequests: "Go to My Requests",
		},
		aiFilter: {
			history: "History",
			newChat: "+ New",
			noConversations: "No conversations yet",
			untitled: "Untitled",
			matchedTag: "{n} matched",
			emptyIntro: "Describe your filter in plain language — the AI writes and runs code over the latest project snapshot.",
			emptyIntroSub: "You can refine with follow-up messages; when a decision materially changes the cohort, the AI will ask you instead of guessing. Typically 1-5 minutes per turn.",
			optCount: "{n} pts",
			letAiDecide: "Let AI decide",
			turnMatched: "Matched {n} patients",
			viewResult: "view →",
			ctrlEnterHint: "Ctrl+Enter to send",
			working: "Working…",
			send: "Send",
			resultPlaceholder: "The latest filter result will appear here.",
			matchedPatients: "Matched {n} patients",
			totalInProject: "{n} in project",
			criteriaFunnel: "Criteria funnel",
			colCriterion: "Criterion",
			colStandalone: "Alone",
			colCumulative: "Cumul.",
			expansionSuggestions: "Suggestions to widen scope",
			estimatedAdditional: "~+{n}",
			applySuggestion: "Apply",
			samplesLabel: "Samples:",
			exportExcel: "Export Excel",
			exportDataset: "Export as dataset",
			startResearch: "Start research analysis",
			confirmAndView: "Confirm & view",
			datasetDialogTitle: "Export as analytics dataset",
			datasetName: "Dataset name",
			datasetHint: "The matched cohort will be flattened (one row per patient) and registered in the research library for workbench analysis.",
			datasetCreated: "Dataset created",
			create: "Create",
			openLibrary: "Open research library",
			retry: "Retry",
			followUpPlaceholder: "Follow up: refine criteria, answer a question, or ask to widen/narrow the cohort…",
			examplePlaceholder: "e.g. Patients diagnosed with ischemic stroke (large-artery atherosclerosis or cardioembolic subtype), with a history of hypertension or diabetes, and either a systolic BP above 150 at any follow-up visit or an NIHSS score of 10 or higher at baseline",
			exportingSnapshot: "Exporting snapshot {docs}/{total}…",
			filterFailed: "AI filter failed",
			starting: "Starting…",
			runInProgress: "A run is already in progress",
			noProjectAccess: "No access to this project",
			conversationGone: "Conversation no longer exists",
			filterRunFailed: "AI filter failed",
			cancelled: "Cancelled",
			autoDecidePrompt: "You decide — proceed with the clinically most reasonable default and do not ask this again.",
			adjustmentPrefix: "Adjustment: ",
			replayMatched: "**Matched {n} patients.**",
			conversationDataGone: "Conversation data is gone",
			openConversationFailed: "Failed to open conversation",
			deleteConversationConfirm: "Delete \"{title}\"? This also removes its cloud copy.",
			deleteConversationTitle: "Delete conversation",
			deleteFailed: "Delete failed",
			matchesDisplayName: "AI filter matches",
			startResearchFailed: "Failed to start research analysis",
			sessionExpiredExport: "Session expired — please log in again",
			exportInProgress: "Another export is already running",
			excelExportFailed: "Excel export failed",
			datasetNamePrefix: "AI filter",
			datasetResult: "{name}: {rows} patients, {cols} columns",
			datasetExportFailed: "Dataset export failed",
			datasetExportInProgress: "Another export is already running",
			datasetExportStartFailed: "Dataset export failed to start",
			excelFilenamePrefix: "AI_filter",
		},
		savedSearches: "Saved searches",
		pickTemplatePlaceholder: "Please select a template",
		group: "Group",
		clearAll: "Clear all",
		addOrPickCondition: "Add or pick a search condition",
		fieldNamePlaceholder: "Search by field name",
		aiFilterTab: "AI filter",
	},
	analysis: {
		title: "Data analysis",
		runAnalysis: "Run analysis",
		results: "Results",
		exportResult: "Export report",
		emptyHint: "Pick fields first, then run the analysis.",
	},
	projectManage: {
		title: "Project list",
		searchPlaceholder: "Search by project name",
		clearModelCache: "Clear model cache",
		clearModelCacheConfirm:
			"Clear all model caches? Users will see a one-off slowdown on the first load afterwards.",
		clearModelCacheTip: "Heads up",
		clearModelCacheSuccess: "Cache cleared. {n} entries removed.",
		newProject: "New project",
		colProjectId: "Project ID",
		colProjectName: "Project",
		colProjectLeader: "Project lead",
		colProjectTerm: "Term",
		colFollowupData: "Follow-up data",
		colViewInfo: "View info",
		colMainCenter: "Lead centre",
		colOperation: "Actions",
		actEdit: "Edit",
		actScene: "Scenario",
		actDatabase: "Database config",
		actFollowup: "Follow-up config",
		actPermissions: "Members & permissions",
		actSubCenter: "Sub-centres",
		actSubProject: "Sub-projects",
		actSchema: "Initial schema",
		actAgent: "Agent config",
		actMetadataHistory: "Metadata history",
		actLifecycle: "Lifecycle & retention",
		actPiiRule: "PII rule registry",
		actConsent: "Consent forms",
		grpSetup: "Setup",
		grpData: "Data",
		grpGovernance: "Governance",
		grpStructure: "Structure",
		lostFollowups: "Orphaned follow-up plans: {n}",
		fixData: "Fix data",
		patientCount: "Patients: {p}; view rows: {v};",
		patientViewMismatch: "--- mismatch ---",
		buildStatus: "Build status: {s};",
		buildBusy: "Building view…",
		buildIdle: "Idle",
		startTime: "Started: {t};",
		endTime: "Ended: {t};",
		execResult: "Result: {r};",
		execSuccess: "Success",
		execFailed: "Failed",
		rebuildView: "Rebuild view",
		appendView: "Patch view",
		recalcCompleteness: "Recalc completeness",
		opSent: "Request submitted",
		recalcDone: "Recalc complete. {n} patients processed.",
		dialogBaseTitle: "Basic info",
		dialogSceneTitle: "Scenario",
		fieldProjectName: "Project name",
		fieldProjectCode: "Project code",
		fieldProjectLeader: "Project lead",
		fieldLeadCenter: "Lead unit",
		fieldStartDate: "Start date",
		fieldEndDate: "End date",
		fieldTarget: "Goals",
		fieldLeaderUnit: "Lead unit",
		fieldCompanyLogo: "Company logo (horizontal)",
		fieldSquareLogo: "Square logo (icon)",
		placeholderSelect: "Select…",
		fieldSpecialty: "Specialty",
		fieldDisease: "Disease",
		fieldSoftwareEnv: "Software surfaces",
		envWeb: "Web",
		envDoctor: "Doctor mini-app",
		envPatient: "Patient mini-app",
		fieldLoginUrl: "Project login URL",
		fieldLoginName: "Project login name",
		fieldLoginImage: "Project login image",
		searchPlaceholderRemote: "Type to search",
	},
	equity: {
		accountInfo: "Account info",
		username: "Username:",
		realNameAuth: "Real-name verification:",
		modify: "Edit",
		notAuthHint: "Real-name verification incomplete — half-price discount unavailable.",
		goAuth: "Verify now",
		levelExpire: "Plan valid until: {date}",
		upgrade: "Upgrade plan",
		memberRights: "Plan benefits",
		categoryProjectMgmt: "Project management",
		categoryAiCollect: "AI data capture",
		categoryAiAnalysis: "AI data analysis",
		categoryIp: "IP services",
		categoryResearch: "Research services",
		rightCreateProject: "Create projects",
		rightCustomForm: "Custom forms",
		rightFollowup: "Follow-up management",
		rightEnrollment: "Enrollment status",
		rightSubProject: "Sub-projects",
		rightUnivariate: "Univariate statistics",
		rightSearch: "Data retrieval",
		rightExport: "Data export",
		rightHistorical: "Historical re-enrollment",
		rightAutoEnroll: "Auto eligibility check",
		rightCrfGen: "Auto-generate CRFs",
		rightCrfFill: "Auto-fill CRFs",
		rightPathology: "Auto-generate pathology reports",
		rightFollowupChat: "Interactive follow-up",
		rightAiSearch: "AI search",
		rightAiStat: "AI statistics",
		rightAiExport: "AI filtered export",
		rightAiEnroll: "AI eligibility",
		rightIpFile: "IP filing",
		rightJointProject: "Joint research filing",
		basicMember: "Basic plan",
		smartMember: "Smart plan",
		joint1Software: "1 free joint copyright filing",
		joint2Software: "2 free independent copyright filings",
		jointAiProject: "Eligible to join the AI medical research consortium",
		currentLevel: "Current plan",
		dialogAuthTitle: "Identity verification",
	},
	order: {
		searchPlaceholder: "Search by order number",
		orderList: "Orders",
		colIndex: "No.",
		colOrderNo: "Order #",
		colPaymentTime: "Paid at",
		colPaymentFees: "Amount",
		colPaymentMethod: "Method",
		methodWechat: "WeChat",
		colContent: "Item",
		colStatus: "Status",
		colInvoiceStatus: "Invoice",
		colOperation: "Actions",
		actInvoice: "Issue invoice",
		statusCreated: "Awaiting payment",
		statusPayed: "Paid",
		statusUsed: "Redeemed",
		invoiceNotIssued: "Not issued",
		invoiceIssued: "Issued",
		dialogTitle: "Invoice details",
		titleSection: "Header",
		fieldAmount: "Invoice amount",
		amountUnit: "RMB",
		fieldHeaderType: "Header type",
		typePersonal: "Personal / non-enterprise",
		typeEnterprise: "Enterprise",
		fieldInvoiceType: "Invoice type",
		invoiceTypeValue: "Standard VAT e-invoice",
		fieldHeader: "Invoice header",
		placeholderInput: "Type here",
		placeholderHeader: "Enter the invoice header",
		fieldTaxNumber: "Tax ID",
		placeholderTaxNumber: "Enter a 15–20 character tax ID",
	},
	subProjectManage: {
		title: "Sub-project list",
		breadCrumb: "Project management / {parent}",
		newSubProject: "New sub-project",
		searchPlaceholder: "Search by sub-project name",
	},
	projectList: {
		projectCode: "Project Code",
		centerCount: "Number of Centres",
		patientCount: "Enrolled Patients",
		subProjects: "Sub-projects",
		openProject: "Open Project",
		emptyHint: "You don't have any projects yet — create one to get started.",
		createProject: "Create Project",
		noticeSystem: "System Notice",
		noticeOcr: "OCR Recognition",
		noticeChallenge: "Data Challenge",
	},
	projectHead: {
		projectName: "Project",
		rootProjectName: "Root project",
		subProjectName: "Sub-project",
		parentProject: "Parent cohort",
		specialty: "Specialty",
		disease: "Disease",
		formConfig: "Form configuration",
		followUpConfig: "Follow-up configuration",
		schemaSnapshot: "Schema snapshots",
	},
	home: {
		leadCentre: "Lead Centre",
		maskedHospital: "**** Hospital",
		projectLead: "Project Lead",
		projectTerm: "Project Term",
		pendingReply: "Pending Replies",
		clickToReply: "Click to view & reply →",
		totalCases: "Total Cases",
		newCasesThisMonth: "New Cases (This Month)",
		avgCompleteness: "Avg. Completeness",
		followUpOverdue: "Follow-ups Overdue",
		view: "View",
		notifications: "Project Notifications",
		index: "No.",
		notificationType: "Type",
		notificationContent: "Content",
		count: "Count",
		enrollmentTrend: "Enrollment",
		genderRatio: "Gender",
		ageDistribution: "Age Distribution",
	},
};
